<template>
  <div class="page checkout">

    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->

    <!--        </div> -->


    <v-container>
      <h2 class="text-center mt-7" style="margin-bottom: 2px;">Bestellung & Bezahlung für
        <span v-if="$store.getters.selectedOrderModeByUser === 'inhouse' && plannedAnkunftszeit?.utc">
        <span class="text-no-wrap"><br>🍽️ Zum Hier essen</span> mit geplanter Ankunftszeit
        am {{ plannedAnkunftszeit.dayOfMonth }}.{{ plannedAnkunftszeit.month }},
        <span class="text-no-wrap">{{ plannedAnkunftszeit.time }} Uhr</span>
      </span>
        <span v-else>
        <span class="text-no-wrap" v-if="$store.state.orderArea">{{ $store.state.orderArea }}</span>
        <span class="text-no-wrap" v-else>Tisch {{ $store.getters.table }}</span>
        </span>
      </h2>
    </v-container>
    <div class="text-center">
      <!--            <h2 style="margin-bottom: 20px" v-if="usecase === 'inhouse'">Gesamtsumme: {{total | priceTotal}}</h2>-->
      <!--            <h2 style="margin-bottom: 20px" v-else>Gesamtsumme: {{total | priceTotal}}</h2>-->
      <h4 class="mb-6">Gesamtsumme: <span class="textFont">{{ total | priceTotal }}</span></h4>
      <!--            <div>Bestellen zum Abholen</div>-->
    </div>

    <v-container class="ccontainer" grid-list-md>
      <!--        <v-container class="bigger-input" grid-list-md>-->

      <div class="kioskCheckoutContainer">
        <v-stepper v-model="currentStep" vertical class="vvd orderform" id="stepper">

          <v-stepper-step :complete="currentStep > 1" step="1" @click.native.passive="currentStep = 1">
            <div class="nice-title titleFont">Deine Bestelldaten</div>
            <!--                    <div class="nice-title small">Bitte überprüfe deine Daten</div>-->
          </v-stepper-step>
          <v-stepper-content step="1">
            <!--                    <div v-if="!hasFd" class="hinweis">-->
            <!--                        &lt;!&ndash;                        <v-icon>mdi-information-variant</v-icon>&ndash;&gt;-->
            <!--                        <div>Deine Eingabe wird lokal gespeichert, um zukünftige Bestellungen zu erleichtern 👍</div>-->
            <!--                    </div>-->
            <!--                    <h4 class="mb-1" v-if="asGuest">Bestellung als Gast</h4>-->
            <div v-if="usecase.length > 0" id="checkData">
              <!--                        <h4>Überprüfe deine Daten&nbsp;&nbsp;<v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                        </v-icon>-->
              <!--                        </h4>-->
              <div class="bestelldaten pt-1">
                <v-form v-show="showForm" @submit.prevent="" ref="inhouseMpDataForm" v-model="valid" lazy-validation>
                  <!--                                <div class="d-flex">-->
                  <!--                                    <v-text-field-->
                  <!--                                            v-vaalue="store.getters.table"-->
                  <!--                                            label="Tischnummer"-->
                  <!--                                            illed hide-details-->
                  <!--                                            readonly-->
                  <!--                                    ></v-text-field>    -->
                  <!--                                    <div>Edit</div>-->
                  <!--                                </div>-->
                  <!--                                <div>Tischnummer: {{$store.getters.table}}</div>-->
                  <!--                                <v-text-field-->
                  <!--                                        v-if="!$store.state.orderArea"-->
                  <!--                                        v-model="$store.getters.table"-->
                  <!--                                        label="Tischnummer"-->
                  <!--                                        illed hide-details-->
                  <!--                                        readonly-->
                  <!--                                ></v-text-field>-->
                  <div class="prelative">
                    <v-text-field
                      outlined
                      :value="name" @input="updateName"
                      label="Name*"
                      :rules="nameRules"
                      placeholder="Dein Name"
                      illed hide-details
                      @focus="hideToolbar"
                      @blur="unhideToolbar"
                    ></v-text-field>
                    <div v-if="name" class="absClear">
                      <v-icon class="myBlack" @click.passive.stop="name=''"
                      >mdi-close
                      </v-icon>
                    </div>
                  </div>

                  <div class="prelative">
                    <v-text-field
                      outlined
                      :value="email" @input="updateEmail"
                      :rules="emailRules"
                      ref="email"
                      label="E-Mail (vorgeschrieben für Online-Zahlung)"
                      illed hide-details
                      @focus="hideToolbar"
                      @blur="unhideToolbar"
                    ></v-text-field>
                    <div v-if="email" class="absClear">
                      <v-icon class="myBlack" @click.passive.stop="email=''"
                      >mdi-close
                      </v-icon>
                    </div>
                  </div>

                  <template v-if="$store.state.enableOrderNote">
                    <div class="prelative" v-if="selfServiceEnabled">
                      <v-text-field
                        outlined
                        ref="phone"
                        @keydown="phoneKeydown($event)"
                        :value="phone" @input="updatePhone"
                        label="Mobilnummer (optional)"
                        placeholder=""
                        illed
                      ></v-text-field>
                      <div v-if="phone" class="absClear">
                        <v-icon class="myBlack" @click.passive.stop="phone=''"
                        >mdi-close
                        </v-icon>
                      </div>
                    </div>
                    <h4 class="mt-4 mb-2">Hinweise zur Bestellung</h4>
                    <v-text-field
                      outlined
                      hide-details
                      ref="note"
                      v-model="note"
                      label="Notiz"
                      @keyup.enter="finishStep1"
                      clearable
                      illed
                    ></v-text-field>
                  </template>
                  <template v-else>
                    <div class="prelative" v-if="selfServiceEnabled">
                      <v-text-field
                        outlined
                        ref="phone"
                        @keydown="phoneKeydown($event)"
                        :value="phone" @input="updatePhone"
                        :rules="phoneRules"
                        :label="selfServiceEnabled ? 'Mobilnummer*' : 'Mobilnummer (optional)'"
                        placeholder=""
                        illed
                        @keyup.enter="finishStep1"
                      ></v-text-field>
                      <div v-if="phone" class="absClear">
                        <v-icon class="myBlack" @click.passive.stop="phone=''"
                        >mdi-close
                        </v-icon>
                      </div>
                    </div>
                  </template>


                  <!--                                &lt;!&ndash;                                label="Mobilnummer* (ohne Ländervorwahl)"&ndash;&gt;-->
                  <!--                                &lt;!&ndash;                            <pre v-if="$refs.phone">&ndash;&gt;-->
                  <!--                                &lt;!&ndash;      hasError: {{$refs.phone.hasError}}&ndash;&gt;-->
                  <!--                                &lt;!&ndash;      valid: {{$refs.phone.valid}}&ndash;&gt;-->
                  <!--                                &lt;!&ndash;    </pre>&ndash;&gt;-->
                  <!--                                <p class="hinweis">Hinweis: Deine Daten werden nur zum Zweck dieser Bestellung-->
                  <!--                                    verwendet und nicht-->
                  <!--                                    &lt;!&ndash;                                zu keinem Zeitpunkt &ndash;&gt;-->
                  <!--                                    an Dritte weitergegeben. Deine Mobilnummer benötigen wir für evtl.-->
                  <!--                                    Rückfragen.</p>-->

                  <!--                                <h4 class="mt-7 mb-4">Rechnungsadresse</h4>-->
                  <!--                                &lt;!&ndash;                            <form>&ndash;&gt;-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="name"-->
                  <!--                                        label="Vor- und Nachname"-->
                  <!--                                        illed hide-details-->
                  <!--                                        v-if="!invoiceAddress.company || invoiceAddress.company.length === 0"-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="invoiceAddress.company"-->
                  <!--                                        label="Firma (optional)"-->
                  <!--                                        illed hide-details-->
                  <!--                                        required-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="invoiceAddress.street"-->
                  <!--                                        label="Straße und Hausnummer*"-->
                  <!--                                        illed hide-details-->
                  <!--                                        required-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="invoiceAddress.plz"-->
                  <!--                                        label="Postleitzahl*"-->
                  <!--                                        illed hide-details-->
                  <!--                                        required-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="invoiceAddress.city"-->
                  <!--                                        label="Stadt*"-->
                  <!--                                        illed hide-details-->
                  <!--                                        required-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->

                  <!--                                <table class="maxw myTable">-->
                  <!--                                    <tr>-->
                  <!--                                        <td>-->
                  <!--                                            <v-text-field-->
                  <!--                                                    v-model="invoiceAddress.plz"-->
                  <!--                                                    label="PLZ*"-->
                  <!--                                                    illed hide-details-->
                  <!--                                                    required-->
                  <!--                                                    @focus="hideToolbar"-->
                  <!--                                                    @blur="unhideToolbar"-->
                  <!--                                            ></v-text-field>-->
                  <!--                                        </td>-->
                  <!--                                        <td>-->
                  <!--                                            <v-text-field-->
                  <!--                                                    v-model="invoiceAddress.city"-->
                  <!--                                                    label="Stadt*"-->
                  <!--                                                    illed hide-details-->
                  <!--                                                    required-->
                  <!--                                                    @focus="hideToolbar"-->
                  <!--                                                    @blur="unhideToolbar"-->
                  <!--                                            ></v-text-field>-->
                  <!--                                        </td>-->
                  <!--                                    </tr>-->
                  <!--                                </table>-->
                </v-form>

                <!--                            <v-checkbox-->
                <!--                                    class="d-inline-block"-->
                <!--                                    v-model="sameAsInvoiceAddress"-->
                <!--                                    label="Lieferadresse gleich Rechnungsadresse"-->
                <!--                            ></v-checkbox>-->

                <!--                            <div v-if="!sameAsInvoiceAddress">-->
                <!--                                <h4 class="mt-7 mb-4">Lieferadresse</h4>-->
                <!--                                <v-text-field-->
                <!--                                        v-model="deliveryAddress.company"-->
                <!--                                        label="Firma (optional)"-->
                <!--                                        illed hide-details-->
                <!--                                        required-->
                <!--                                        @focus="hideToolbar"-->
                <!--                                        @blur="unhideToolbar"-->
                <!--                                ></v-text-field>-->

                <!--                                <v-text-field-->
                <!--                                        v-model="deliveryAddress.street"-->
                <!--                                        label="Straße und Hausnummer"-->
                <!--                                        illed hide-details-->
                <!--                                        required-->
                <!--                                        @focus="hideToolbar"-->
                <!--                                        @blur="unhideToolbar"-->
                <!--                                ></v-text-field>-->

                <!--                                <table class="maxw myTable">-->
                <!--                                    <tr>-->
                <!--                                        <td>-->
                <!--                                            <v-text-field-->
                <!--                                                    v-model="deliveryAddress.plz"-->
                <!--                                                    label="PLZ"-->
                <!--                                                    illed hide-details-->
                <!--                                                    required-->
                <!--                                                    @focus="hideToolbar"-->
                <!--                                                    @blur="unhideToolbar"-->
                <!--                                            ></v-text-field>-->
                <!--                                        </td>-->
                <!--                                        <td>-->
                <!--                                            <v-text-field-->
                <!--                                                    v-model="deliveryAddress.city"-->
                <!--                                                    label="Ort"-->
                <!--                                                    illed hide-details-->
                <!--                                                    required-->
                <!--                                                    @focus="hideToolbar"-->
                <!--                                                    @blur="unhideToolbar"-->
                <!--                                            ></v-text-field>-->
                <!--                                        </td>-->
                <!--                                    </tr>-->
                <!--                                </table>-->
                <!--                                <v-text-field-->
                <!--                                        v-model="deliveryAddress.etage"-->
                <!--                                        label="Etage"-->
                <!--                                        illed hide-details-->
                <!--                                        required-->
                <!--                                        @focus="hideToolbar"-->
                <!--                                        @blur="unhideToolbar"-->
                <!--                                ></v-text-field>-->
                <!--                            </div>-->


              </div>


              <!--                        <div class="bestelldaten pointer" v-else @click.passive="gotoAccount">-->
              <!--                                                        <table>-->
              <!--                                                            <tr>-->
              <!--                                                                <td>Firma (optional):</td>-->
              <!--                                                                <td>{{company}}-->
              <!--                                                                    <v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                                                                    </v-icon>-->
              <!--                                                                </td>-->
              <!--                                                            </tr>-->
              <!--                                                            <tr>-->
              <!--                                                                <td>Name:</td>-->
              <!--                                                                <td>{{$store.state.user.name}}-->
              <!--                                                                    <v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                                                                    </v-icon>-->
              <!--                                                                </td>-->
              <!--                                                            </tr>-->
              <!--                                                            <tr>-->
              <!--                                                                <td>Mobilnummer:</td>-->
              <!--                                                                <td>{{$store.state.user.phone}}-->
              <!--                                                                    <v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                                                                    </v-icon>-->
              <!--                                                                </td>-->
              <!--                                                            </tr>-->
              <!--                                                        </table>-->
              <!--                        </div>-->

              <!--                        <div class="spacer-15"></div>-->
              <!--                        <div class="pointer" @click.passive="changeFiliale"><h4 class="d-inline-block">Abholort</h4>-->
              <!--                            <v-icon>mdi-pencil</v-icon>-->
              <!--                        </div>-->
              <!--                        <div>{{$store.getters.selectedStore.strasse}}</div>-->
              <!--                        <div>{{$store.getters.selectedStore.plz}} {{$store.getters.selectedStore.ort}}-->
              <!--                        </div>-->


              <!--                        <table>-->
              <!--                            <tr>-->
              <!--                                <td class="vtop"><h4>Abholort</h4>-->
              <!--                                    <div>{{$store.getters.selectedStore.strasse}}</div>-->
              <!--                                    <div>{{$store.getters.selectedStore.plz}} {{$store.getters.selectedStore.ort}}-->
              <!--                                    </div>-->
              <!--                                </td>-->
              <!--                                <td style="width: 2vw"></td>-->
              <!--                                <td class="vtop"><h4>Öffungszeit Morgen</h4>-->
              <!--                                    <div>{{$store.getters.selectedStore.openingHours | tomorrow}}</div>-->
              <!--                                </td>-->
              <!--                                <td style="width: 1vw"></td>-->
              <!--                                <td class="vtop"><h4>Mindestbestellwert</h4>-->
              <!--                                    <div> {{$store.getters.selectedStore.minOrderAmount | price}}</div>-->
              <!--                                </td>-->
              <!--                            </tr>-->
              <!--                        </table>-->
              <!--            <div class="spacer-15"></div>-->
              <!--                        <h4>Abholdatum</h4>-->
              <!--                        Morgen, {{displayTomorrow}}-->
              <!--                        <v-text-field-->
              <!--                                hide-details-->
              <!--                                illed-->
              <!--                                disabled-->
              <!--                                class="d-inline-block"-->
              <!--                                :value="displayTomorrow"-->
              <!--                        ></v-text-field>-->

              <!--                        <div class="spacer-15"></div>-->
              <!--                        <h4 class="d-inline-block">Abholzeit:</h4><span class="ml-2">Morgen, {{displayTomorrow}}</span>-->
              <!--                        <p>Je genauer Sie die Uhrzeit angeben, desto frischer erhalten Sie Ihre Backwaren!</p>-->

              <!--                        <h5 class="d-inline-block mr-3 text-none"-->
              <!--                            :class="{pulsing: !(time && time.value)}"-->
              <!--                        >Frühstens ab</h5>-->

              <!--                        <v-select-->
              <!--                                hide-details-->
              <!--                                :items="times"-->
              <!--                                item-text="display"-->
              <!--                                v-model="time"-->
              <!--                                class="d-inline-block abholzeit"-->
              <!--                                :class="{selectBlinker: !(time && time.value)}"-->
              <!--                                return-object-->
              <!--                                illed-->
              <!--                                placeholder="Wählen Sie eine Abholzeit aus"-->
              <!--                        ></v-select>-->
              <!--                        <div class="spacer-15"></div>-->


              <!--                            <h4>Bemerkung zu deiner Bestellung</h4>-->

              <div class="mt-2">
                <!--              <div class="error&#45;&#45;text mt-2 mb-4" v-if="step1Error && initialTry">{{ step1Error }}</div>-->
                <v-btn class="primepulsing btn-df weiter"
                       @click.native.passive="finishStep1">
                  Weiter
                </v-btn>
              </div>
              <!--                    <v-btn class="mt-3"-->
              <!--                           @click.native.passive="currentStep = 1">-->
              <!--                        Zurück-->
              <!--                    </v-btn>-->
            </div>


            <!--                <v-btn color="primary" @click="currentStep = 2">Continue</v-btn>-->
          </v-stepper-content>


          <v-stepper-step :complete="currentStep > 2" step="2" @click.native.passive="currentStep = 2">
            <div class="nice-title titleFont">Trinkgeld geben</div>
            <!--                    <div class="nice-title small">Bitte überprüfe deine Daten</div>-->
          </v-stepper-step>
          <v-stepper-content step="2">
            <div class="pl-5 mt-2 flex-container align-center" style="font-size: 1.2em; row-gap: 10px">
              <div class="bold">{{ $store.getters.payerSum | price }}</div>
              <div class="ml-2 mr-2">+</div>
              <v-text-field dense
                            outlined class="inputTipAmount" :class="{'tipInputAnimation': showTipInputAnimation}"
                            hide-details
                            v-model="inputTipAmount"
                            type="number"
              />
              <div class="ml-2 bold">€</div>
              <div class="ml-2 bold hidden-xs-only">Trinkgeld</div>
              <div class="ml-2 mr-2">=</div>
              <div class="bold mr-2">{{ total | price }}</div>
              <!--            <div class="" v-if="total % 1 !== 0">-->
              <!--              <v-btn class="btn-mini"-->
              <!--                     @click="roundUpTip"-->
              <!--              >Aufrunden-->
              <!--              </v-btn>-->
              <!--            </div>-->
            </div>
            <!--          <div>DEBUG tipAmount {{ tipAmount }}</div>-->
            <!--          <div>DEBUG secureTip {{ secureTip }}</div>-->
            <div class="flex-container tipContainer">


              <div class="pointer mar-15 mt-3" @click="clickCustomTip">
                <!--              <v-img class="invisible"-->
                <!--                     max-height="38"-->
                <!--                     max-width="38"-->
                <!--                     style="margin: auto;"-->
                <!--                     src="../assets/icons/15.png"-->
                <!--              ></v-img>-->
                <div class="prelative">
                  <div class="tipBox pointer superCenter"
                       :class="(tipType === 'none' && customTipActive) ? 'tipBoxSelected':''">
                    <div class="text-center bold">
                      <div>Eigener</div>
                      <div>Betrag</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pointer mar-15 mt-3" @click="clickZeroTip">
                <div class="prelative">
                  <div class="tipBox pointer superCenter"
                       :class="(tipType === 'none' && !customTipActive) ? 'tipBoxSelected':''">
                    <div class="text-center bold">
                      <div>Ohne</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pointer mar-15 mt-3" @click="updateTipPercent('a')">
                <!--              <v-img-->
                <!--                max-height="38"-->
                <!--                max-width="38"-->
                <!--                style="margin: auto;"-->
                <!--                src="../assets/icons/5.png"-->
                <!--              ></v-img>-->
                <div
                  class="pointer tipBox superCenter"
                  :class="tipType !== 'none' && tipPercent === tipConfig['a'] && calcTipAmount('a')===inputTipAmount ? 'tipBoxSelected' : ''"
                >
                  <div class="text-center">
                    <div class="tipAmount bold">{{ tipConfig['a'] }}%</div>
                    <div>{{ calcTipAmount('a') | price }}</div>
                  </div>
                </div>
              </div>
              <div class="pointer mar-15 mt-3" @click="updateTipPercent('b')">
                <!--              <v-img-->
                <!--                max-height="38"-->
                <!--                max-width="38"-->
                <!--                style="margin: auto;"-->
                <!--                src="../assets/icons/10.png"-->
                <!--              ></v-img>-->
                <div
                  class="pointer tipBox superCenter"
                  :class="tipType !== 'none' && tipPercent === tipConfig['b'] && calcTipAmount('b')===inputTipAmount ? 'tipBoxSelected' : ''"
                >
                  <div class="text-center">
                    <div class="tipAmount bold">{{ tipConfig['b'] }}%</div>
                    <div>{{ calcTipAmount('b') | price }}</div>
                  </div>
                </div>
              </div>
              <div class="pointer mar-15 mt-3" @click="updateTipPercent('c')">
                <!--              <v-img-->
                <!--                max-height="38"-->
                <!--                max-width="38"-->
                <!--                style="margin: auto;"-->
                <!--                src="../assets/icons/15.png"-->
                <!--              ></v-img>-->
                <div
                  class="pointer tipBox superCenter"
                  :class="tipType !== 'none' && tipPercent === tipConfig['c'] && calcTipAmount('c')===inputTipAmount ? 'tipBoxSelected' : ''"
                >
                  <div class="text-center">
                    <div class="tipAmount bold">{{ tipConfig['c'] }}%</div>
                    <div>{{ calcTipAmount('c') | price }}</div>
                  </div>
                </div>
              </div>

              <div class="pointer mar-15 mt-3" v-if="total % 1 !== 0" @click="roundUpTip">
                <!--              <v-img class="invisible"-->
                <!--                     max-height="38"-->
                <!--                     max-width="38"-->
                <!--                     style="margin: auto;"-->
                <!--                     src="../assets/icons/15.png"-->
                <!--              ></v-img>-->
                <div class="prelative">
                  <div class="tipBox pointer superCenter">
                    <div class="text-center bold">
                      <!--                    <div v-if="tipType!=='none'">{{ tipConfig[tipType] }}%</div>-->
                      <div>Auf-<br>runden</div>
<!--                      <div style="font-size: 0.8em">Aufrunden</div>-->
                    </div>
                  </div>
                </div>
              </div>

            </div> <!-- eof tip container-->

            <div class="mt-7">
              <div class="error--text mt-2 mb-4" v-if="step2Error && initialTry">{{ step2Error }}</div>
              <v-btn class="pulsing btn-df weiter"
                     :disabled="!step2Ok"
                     @click.native.passive="finishStep2">
                Weiter
              </v-btn>
              <v-btn class="btn-df weiter grayBtn"
                     @click.native.passive="currentStep = 1">
                Zurück
              </v-btn>
            </div>
          </v-stepper-content>


          <v-stepper-step :complete="currentStep > 2" step="3">
            <div class="nice-title titleFont">Bezahlung<span v-if="psp === 'bar'">: Bar</span>
              <span v-if="psp === 'beiAbholung'">: Bei Abholung</span>
              <span v-if="psp === 'vorkasse'">: Vorkasse</span>
              <span v-if="psp === 'credit'">: Girocard/Debitkarte oder Kreditkarte</span>
              <span v-if="psp === 'wallet'">: Apple/Google Pay</span>
              <span v-if="psp === 'paypal'">: PayPal</span>
              <span v-if="psp === 'waiter'">: beim Kellner</span>
            </div>
          </v-stepper-step>
          <v-stepper-content id="paymentRadios" step="3">
            <!--          <div class="yellowHinweis pa-4 mb-5">-->
            <!--            HINWEIS: Die Bestellnummer erhälst du direkt nach der Online-Bezahlung. Solange du keine-->
            <!--            Bestellnummer hast, buchen wir nichts ab!-->
            <!--          </div>-->
            <h4 v-if="!showSubmitButton">Wähle eine Zahlungsmethode:</h4>
            <!--                <v-radio-group v-model="onlinePay" class="vvd-radio" @click="handleScrollingInStep3">-->
            <v-radio-group light v-model="psp" class="vvd-radio" v-if="showSubmitButton"
                           hide-details
                           @click.native.passive="clickRadio">
              <!--                        <v-radio-->
              <!--                                key="bar"-->
              <!--                                label="Barzahlung"-->
              <!--                                :value="'bar'"-->
              <!--                                hide-details-->
              <!--                        ></v-radio>-->
              <!--                                        <v-radio-->
              <!--                                                key="vorkasse"-->
              <!--                                                label="Vorkasse"-->
              <!--                                                :value="'vorkasse'"-->
              <!--                                                hide-details-->
              <!--                                        ></v-radio>-->
              <!--            <v-radio v-if="$store.getters.loggedIn"-->
              <!--                     key="customerCard" label="Kundenkarte" :value="'customerCard'" hide-details-->
              <!--                     class="mb-4"></v-radio>-->
              <v-radio v-if="showGoodpayCc" key="credit" label="Girocard/Debitkarte oder Kreditkarte" :value="'credit'"
                       hide-details
                       class="mb-4">
              </v-radio>
              <v-radio v-if="showPaypal" key="paypal" label="PayPal/Lastschrift" :value="'paypal'" hide-details
                       class="mb-4"></v-radio>
              <v-radio v-if="showGoodpayGoogleWallet" key="googlewallet" label="Google Pay" :value="'googlewallet'"
                       hide-details
                       class="mb-4"></v-radio>
              <v-radio v-if="showGoodpayAppleWallet" key="applewallet" label="Apple Pay" :value="'applewallet'"
                       hide-details
                       class="mb-4"></v-radio>
              <!--            <v-radio v-if="showGoodpayWallet && hasPR" key="wallet" label="Apple/Google Pay" :value="'wallet'"-->
              <!--                     hide-details-->
              <!--                     class="mb-4"></v-radio>-->
            </v-radio-group>

            <!--                <v-btn :color="onlinePay === false ? 'success' : null"-->
            <!--                       class="myBtn"-->
            <!--                       @click.native.passive="onlinePay = false">-->
            <!--                    Barzahlung-->
            <!--                </v-btn>-->
            <!--                <v-btn :color="onlinePay === true ? 'success' : null"-->
            <!--                       class="myBtn"-->
            <!--                       @click.native.passive="onlinePay = true">-->
            <!--                    Online Payment-->
            <!--                </v-btn>-->

            <div v-show="psp ==='credit'">

              <div v-show="paymentMethods.length > 0">
                <div class="paymentMethodsBox pointer" v-for="pMethod in paymentMethods" :key="pMethod.aliasId"
                     @click.passive="selectMethod(pMethod)">
                  <!--                                :class="{cardSelected: selectedAliasId === pMethod.aliasId}"-->
                  <table class="paymentRowsTable">
                    <tr>
                      <td style="width: 40px">
                        <v-icon class="myBlack" v-if="selectedAliasId === pMethod.aliasId">
                          mdi-check-circle-outline
                        </v-icon>
                        <v-icon class="myBlack" v-else>mdi-radiobox-blank</v-icon>
                      </td>
                      <td>
                        <div>{{ pMethod.label }} {{ pMethod.xxxNumber }}</div>
                        <div class="expLabel">{{ pMethod.exp }}</div>
                      </td>
                      <td class="text-right">
                        <v-btn class="btn-mini" @click.native.passive="gotoPms(true)">Andere Karte
                        </v-btn>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>

              <div v-if="enableGoodpay && paymentMethods.length === 0" class="pb-5">
                <v-btn class="btn-df" @click.native.passive="gotoPms">
                  Karte hinzufügen
                  <!--                                <v-icon right class="myWhite">mdi-chevron-right</v-icon>-->
                </v-btn>
              </div>

              <div class="acceptAgbs align-center mt-4">
                <div
                  @click.passive="accceptedAgbs = !accceptedAgbs"
                  class="option pointer" :class="{selected: accceptedAgbs}">
                  <v-icon v-if="accceptedAgbs">
                    mdi-check-box-outline
                  </v-icon>
                  <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                </div>
                <div class="fasterGrow checkbox-label">
                  <AcceptAgbsText></AcceptAgbsText>
                </div>
              </div>

              <div v-show="showGpSubmit">
                <div>
                  <v-btn class="mt-6 mb-2 orderBtn wallet-width text-none rounded100" color="green" dark
                         v-show="!$store.getters.showLoading"
                         @click.native.passive="submitCc">
                    <!--<v-icon left class="">mdi-lock-check</v-icon>-->
                    Zahlungspflichtig bestellen
                  </v-btn>
                </div>

                <div>
                  <orderconsent></orderconsent>
                </div>
              </div>
            </div>

            <div v-show="psp.includes('wallet')">

              <!--             Goodpay Testcard: 9010003150000001-->
              <!--            Testcards: https://test.saferpay.com/vt2/Api/Post/270028/17759980/inri9t9e0tw537wlils8o65l8"-->

              <div class="pb-5" v-show="psp === 'googlewallet'">

                <div class="acceptAgbs align-center mt-2 mb-4">
                  <div
                    @click.passive="accceptedAgbs = !accceptedAgbs"
                    class="option pointer" :class="{selected: accceptedAgbs}">
                    <v-icon v-if="accceptedAgbs">
                      mdi-check-box-outline
                    </v-icon>
                    <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                  </div>
                  <div class="fasterGrow checkbox-label">
                    <AcceptAgbsText></AcceptAgbsText>
                  </div>
                </div>

                <!--              Google Pay UI -->
                <div v-show="goodpayHasPaymentRequest && email && !$store.getters.showLoading"
                     class="walletButton"
                     ref="googlePay"
                     @click="googlePaymentClicked('google-pay')"></div>
                <br/>
                <!--              <div id="GoogleResponse"></div>-->
              </div>

              <div class="pb-5" v-show="psp === 'applewallet'">

                <div class="acceptAgbs align-center mt-2 mb-4">
                  <div
                    @click.passive="accceptedAgbs = !accceptedAgbs"
                    class="option pointer" :class="{selected: accceptedAgbs}">
                    <v-icon v-if="accceptedAgbs">
                      mdi-check-box-outline
                    </v-icon>
                    <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                  </div>
                  <div class="fasterGrow checkbox-label">
                    <AcceptAgbsText></AcceptAgbsText>
                  </div>
                </div>

                <!--              Apple Pay UI -->
                <div v-show="canMakePayments && email && !$store.getters.showLoading"
                     class="walletButton">
                  <apple-pay-button
                    buttonstyle="black"
                    class="pointer"
                    type="plain"
                    locale="de-DE"
                    @click="onApplePaymentButtonClicked"
                  ></apple-pay-button>
                </div>
                <br/>
                <!--              <div id="GoogleResponse"></div>-->
              </div>


              <!--                        v-show="consent"-->
              <div v-show="psp.includes('wallet')">
                <orderconsent></orderconsent>
              </div>

              <div v-if="psp === 'credit' && selectedAliasId.length > 0">
                <orderconsent></orderconsent>
              </div>

              <!--            <div style="padding-top: 15px;"><img class="invertImg" src="../assets/icons/powered_by_credit.png"></div>-->

              <!--                        <div>Hinweis: Deine Kreditkarte wird nur belastet, wenn {{$store.state.brandName}} deine-->
              <!--                            Bestellung-->
              <!--                            bestätigt hat.-->
              <!--                        </div>-->
            </div>


            <div v-if="psp === 'bar' || psp === 'customerCard'">
              <div
                v-if="showCustomerCard">
                <div
                  v-if="this.total <= $store.getters.cards.find(c => c.rfid === $store.getters.bbnUser.primaryCardId).accounts.find(a => a.accountType === 'CRED').balance">
                  <div class="mt-2 mb-2">Das Guthaben von
                    {{
                      $store.getters.cards.find(c => c.rfid === $store.getters.bbnUser.primaryCardId).accounts.find(a => a.accountType === 'CRED').balance
                    }}
                    {{
                      $store.getters.cards.find(c => c.rfid === $store.getters.bbnUser.primaryCardId).accounts.find(a => a.accountType === 'CRED').symbol
                    }}
                    ist ausreichend
                  </div>
                  <div>
                    <v-btn class="mt-3 mb-5 orderBtn wallet-width text-none rounded100" color="green" dark
                           v-show="showSubmitButton && !$store.getters.showLoading"
                           @click.native.passive="doOrder">
                      <!--<v-icon left class="">mdi-lock-check</v-icon>-->
                      Zahlungspflichtig bestellen
                    </v-btn>
                  </div>
                  <orderconsent></orderconsent>
                </div>
                <div v-else>
                  <div class="mt-2 mb-2">Das Guthaben von
                    {{
                      $store.getters.cards.find(c => c.rfid === $store.getters.bbnUser.primaryCardId).accounts.find(a => a.accountType === 'CRED').balance
                    }}
                    {{
                      $store.getters.cards.find(c => c.rfid === $store.getters.bbnUser.primaryCardId).accounts.find(a => a.accountType === 'CRED').symbol
                    }}
                    ist <span class="bold">nicht ausreichend</span>
                  </div>
                  <div>
                    <v-btn class="btn-mini mt-2 mb-2" @click.passive.stop="chooseCustomercard">Andere Karte wählen
                    </v-btn>
                  </div>
                  <div>
                    <v-btn class="btn-mini mt-2 mb-2" @click="psp = ''">Andere Zahlungsmethode wählen</v-btn>
                  </div>
                </div>
              </div>
              <div v-else>
                <!--              <div class="bold">Keine Guthabenkarte</div>-->
                <div>
                  <v-btn class="btn-mini mt-2 mb-2" @click="$ebus.$emit('goto',{name:'Karten'})">Hauptkarte auswählen
                  </v-btn>
                </div>
                <div>
                  <v-btn class="btn-mini mt-2 mb-2" @click="psp = ''">Andere Zahlungsmethode wählen</v-btn>
                </div>
              </div>
            </div>

            <!--                                    <div v-if="psp === 'vorkasse'">-->
            <!--                                        <orderconsent></orderconsent>-->
            <!--                                        <v-btn class="mt-3 myBtn orderBtn"-->
            <!--                                               large-->
            <!--                                               dark-->
            <!--                                               @click.native.passive="doOrder">-->
            <!--                                            &lt;!&ndash;                          mdi-send-lock  mdi-lock-check&ndash;&gt;-->
            <!--                                            <v-icon left class="">mdi-lock-check</v-icon>-->
            <!--                                            Zahlungspflichtig bestellen-->
            <!--                                        </v-btn>-->
            <!--                                    </div>-->


            <div v-show="psp === 'paypal'">
              <!--                        v-show="consent"-->
              <div class="acceptAgbs align-center mt-3">
                <div
                  @click.passive="accceptedAgbs = !accceptedAgbs"
                  class="option pointer" :class="{selected: accceptedAgbs}">
                  <v-icon v-if="accceptedAgbs">
                    mdi-check-box-outline
                  </v-icon>
                  <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                </div>
                <div class="fasterGrow checkbox-label">
                  <AcceptAgbsText></AcceptAgbsText>
                </div>
              </div>

              <div id="paypal-button-container" class="walletButtonWidth pt-3"></div>
              <table>
                <tr>
                  <!--                                <td class="vtop">-->
                  <!--                                    <v-checkbox-->
                  <!--                                            class="d-inline-block"-->
                  <!--                                            v-model="consent"></v-checkbox>-->
                  <!--                                </td>-->
                  <td>
                    <orderconsent></orderconsent>
                  </td>
                </tr>
              </table>


              <!--                        <div style="padding: 15px 0">-->
              <!--                            Hinweis: Dein PayPal Konto wird nur belastet, wenn {{$store.state.brandName}}-->
              <!--                            deine Bestellung bestätigt hat.-->
              <!--                        </div>-->

            </div>

            <v-btn class="bback" @click.native.passive="currentStep = 2">
              Zurück
            </v-btn>

          </v-stepper-content>


          <!--                            <v-stepper-step :complete="currentStep > 4" step="4">-->
          <!--                                Fertig-->
          <!--                            </v-stepper-step>-->
          <!--                            <v-stepper-content step="4"></v-stepper-content>-->

        </v-stepper>
      </div>

    </v-container>

    <!--        <h3>TESt time = {{time}}</h3>-->

    <ssl-seal></ssl-seal>

    <!--        <h2>payment request button</h2>-->

    <!--        <div class="text-center">-->
    <!--            <div class="inlinecenter">-->
    <!--                <div style="width: 250px;">-->
    <!--                    <div id="payment-request-button" style="display: none; margin-top:25px">-->
    <!--                        &lt;!&ndash; A Credit Element will be inserted here. &ndash;&gt;-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h2>Credit card</h2>-->

    <!--        <div>-->
    <!--            <main class="payment">-->
    <!--                <section class="container-lg">-->
    <!--                    <div class="cell example example1">-->
    <!--                        <div class="verifyOverlay">-->
    <!--                            <img ng-src="../v/images/loader.gif">-->
    <!--                        </div>-->
    <!--                        <h3 class="text-center" style="margin: 0 0 25px 0;" translate="checkout.oayWithCC"></h3>-->
    <!--                        <form>-->
    <!--                            <fieldset>-->
    <!--                                <div class="row">-->
    <!--                                    <table class="maxw">-->
    <!--                                        <tr>-->
    <!--                                            <td style="width: 10%;"><label for="example1-name" data-tid="elements_examples.form.name_label"-->
    <!--                                                                           translate="checkout.holder"></label>-->
    <!--                                            </td>-->
    <!--                                            <td style="padding-left: 20px; padding-right: 25px;">-->
    <!--                                                <input id="example1-name"-->
    <!--                                                       data-tid="elements_examples.form.name_placeholder"-->
    <!--                                                       type="text"-->
    <!--                                                       placeholder="Jane Doe"-->
    <!--                                                       required="" autocomplete="name">-->
    <!--                                            </td>-->
    <!--                                        </tr>-->
    <!--                                    </table>-->
    <!--                                </div>-->
    <!--                                &lt;!&ndash;<div class="row">&ndash;&gt;-->
    <!--                                &lt;!&ndash;<label for="example1-email" data-tid="elements_examples.form.email_label">Email</label>&ndash;&gt;-->
    <!--                                &lt;!&ndash;<input id="example1-email" type="email" required="" ng-model="checkout.email">&ndash;&gt;-->
    <!--                                &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                                &lt;!&ndash;<div class="row">&ndash;&gt;-->
    <!--                                &lt;!&ndash;<label for="example1-phone" data-tid="elements_examples.form.phone_label">Phone</label>&ndash;&gt;-->
    <!--                                &lt;!&ndash;<input id="example1-phone" data-tid="elements_examples.form.phone_placeholder" type="tel"&ndash;&gt;-->
    <!--                                &lt;!&ndash;placeholder="(941) 555-0123" required="" autocomplete="tel">&ndash;&gt;-->
    <!--                                &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                            </fieldset>-->
    <!--                            <fieldset>-->
    <!--                                <div class="row">-->
    <!--                                    <div id="example1-card"></div>-->
    <!--                                </div>-->
    <!--                            </fieldset>-->
    <!--                            <button type="submit" data-tid="elements_examples.form.pay_button"><span-->
    <!--                                    translate="checkout.pay"></span>-->
    <!--                                {{checkout.amount | price}}-->
    <!--                            </button>-->
    <!--                            <div class="error" role="alert">-->
    <!--                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">-->
    <!--                                    <path class="base" fill="#000"-->
    <!--                                          d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"></path>-->
    <!--                                    <path class="glyph" fill="#FFF"-->
    <!--                                          d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"></path>-->
    <!--                                </svg>-->
    <!--                                <span class="message"></span></div>-->
    <!--                        </form>-->


    <!--                    </div>&lt;!&ndash;eof cell&ndash;&gt;-->
    <!--                </section>-->
    <!--            </main>-->
    <!--        </div>-->


    <!--        <input id="cardholder-name" type="text">-->
    <!--        &lt;!&ndash; placeholder for Elements &ndash;&gt;-->
    <!--        <div id="card-element"></div>-->
    <!--        <button id="card-button">-->
    <!--            Submit Payment-->
    <!--        </button>-->

    <div class="text-center">
      <!--      <v-btn style="margin-top: 25px" class="text-none btn-df"-->
      <!--             @click.native.passive="gotoSummary">-->
      <!--        Zurück zum Korb-->
      <!--      </v-btn>-->
      <div class="spacer-25"></div>
      <v-btn style="margin-top: 25px" class="text-none btn-mini" @click="$router.go(-1)">
        Bestellung abbrechen
      </v-btn>
    </div>

    <!--        <times-info-dialog :dialog="timesInfoDialog" @close="timesInfoDialog = false"></times-info-dialog>-->

    <div class="spacer-25"></div>

    <!--        <qsignal class="hide-md"></qsignal>-->


  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as bootstrap from '../vendor/bootstrap';
import * as xhr from '../api/xhr.js'
// import * as iframe from "../iframe/iframe";
import * as util from '../vendor/util'
import * as checkoutUtil from '../util/inhouseMPUtil'
// import* as plausi from '../vendor/plausi'
import * as qconst from '../vendor/qconstants';

// TODO activate for online
import * as firebaseUtil from '@/firebase/firebaseUtil'
import * as goodpayUtil from '@/goodpay/goodpayUtil'
// import* as paypalUtil from '../paypal/paypalUtil'
import Orderconsent from "../components/orderconsent";

// import Qsignal from "../components/qsignal";
import SslSeal from "../components/sslSeal";
import {googlePayMerchantId} from "@/goodpay/goodpayUtil";
import {
  action$GoodpayFrontendApi, enableGoodpay, enablePaypal, PROD_ENV, tipConfig
} from "../vendor/qconstants";
import {getGlobalValue, getGlobalValueOrZero, removeGlobalKey, setGlobalKeyValue} from "@/util/globalState";
import {cloneMe, getName1Error, isEmailOk, isIos, isMobileOk, roundToTwo} from "@/vendor/util";
import {CURRENCY_CODE} from "@/goodpay/applePay/applePayUtil";
import {appleCanMakePayments, performApplePayPayment} from "@/goodpay/applePay/apple-pay-js-handler";
import {
  createApplePayPaymentRequest,
} from "@/goodpay/applePay/payment-request-handler";
import {allowedCardAuthMethods, allowedCardNetworks, getGoogleTransactionInfo} from "@/goodpay/googlePay/googlePayUtil";
import AcceptAgbsText from "@/components/AcceptAgbsText.vue";
import {getErrorDetails} from "@/util/globalErrorHandler";
import {isEmptyObject} from "../vendor/util";
// import* as breakpoints from '../vendor/breakpoints'

// import TimesInfoDialog from "../dialogs/TimesInfoDialog";

let recaptchaScript = null;

export default {
  components: {
    AcceptAgbsText,
    Orderconsent,
    SslSeal
  },

  data() {
    return {
      enableGoodpay: enableGoodpay,
      accceptedAgbs: false,
      valid: true,
      showForm: true,
      fromCheckout: false,
      showSubmitButton: true,
      initialTry: false,
      clientId: '',
      fastUnload: false,
      updateInterval: null,
      isInvoiceAddressVisible: false,

      plannedAnkunftszeit: this.$ls.get('userSelectedTargetTime'),

      hasFd: true,

      // phoneRules: [
      //   v => !!v || 'Die Mobilnummer wird benötigt',
      //   // v => /^(?=.*\d)[\d ]+$/.test(v) || 'Dieses Feld darf nur Nummern oder Leerzeichen enthalten',
      //   v => (v.length >= 10) || 'Die Mobilnummer ist zu kurz'
      // ],

      //captcha
      captchaInput: '',
      // numberRule: v  => {
      //     if (!v.trim()) return true;
      //     if (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999) return true;
      //     return 'Number has to be between 0 and 9999';
      // },

      //abholung öffnungszeiten
      abholDatumArray: [
        {value: 'Heute'},
        {value: 'Morgen'}
      ],
      selectedAbholDatum: {value: 'Heute'},//default
      time: null, //{value:'06:45', utc:...}//produces a string i.e. 06:45
      timesToday: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],
      timesTomorrow: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],

      //Formulardaten
      name: '',
      nameRules: [
        v => !getName1Error(v) || 'Bitte vollständigen Namen eingeben',
        // v => (!v && !this.selfServiceEnabled) || !getName2Error(v) || 'Bitte vollständigen Namen eingeben',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-Mail ist erforderlich',
        v => isEmailOk(v) || 'Ungültige E-Mail',
      ],
      phone: '',
      phoneRules: [
        v => (!v && !this.selfServiceEnabled) || !!v || 'Die Mobilnummer wird benötigt',
        // v => /^(?=.*\d)[\d ]+$/.test(v) || 'Dieses Feld darf nur Nummern oder Leerzeichen enthalten',
        v => (!v && !this.selfServiceEnabled) || isMobileOk(v) || 'Die Mobilnummer ist zu kurz'
      ],
      // vorname: '',
      // nachname: '',
      sameAsInvoiceAddress: true,
      invoiceAddress: {
        company: '',
        street: '',
        plz: '',
        city: '',
      },
      deliveryAddress: {
        company: '',
        street: '',
        plz: '',
        city: '',
        etage: '',
      },

      step1Error: '',

      step2Error: '',

      note: '',


      // autoModel: null,
      // {
      //     displayName: '345567 Straße, Maxdorf',
      //         obj: storeObject
      // }

      // selectedStore: {
      //     // plz:'',
      //     // strasse:'',
      //     //   openingHours:
      // },
      // stores: [],
      consent: false,

      showBar: false,
      showGoodpayCc: enableGoodpay,
      showGoodpayGoogleWallet: false,
      showGoodpayAppleWallet: false,
      showPaypal: true,

      hasPR: false,
      wait: false,
      total: 0,

      totalWithoutTip: 0,
      // earlyPaymentIntentId: '',
      // earlyClientSecret: '',

      // deliveryFee: 0,
      // fee: 0,
      // minOrderAmount: 0,

      currentStep: 1,
      usecase: qconst.usecase$tableOrdering,//initial value 'delivery',
      // daySelected: 'asap',

      // time: null, //{value:'06:45'}//produces a string i.e. 06:45
      // times: [
      //     //{ value : '06:45'}
      // ],

      // internalDaySelected: '1',

      psp: '', //none, waiter, bar, credit, paypal

      // consentA: false,
      // consentB: false,

      // deliveryAddress: {
      //     // company: '',
      //     street: '',
      //     plz: '',
      //     city: '',
      //     etage: '',
      // },

      order: {},

      unloadTargetTime: 0,

      //Goodpay Common
      goodpayScriptCreated: false,
      //Goodpay Credit
      goodpayCreditTransaction: null,
      goodpayTxIsForAliasId: '',
      goodpayTxToken: '',
      goodpayCreditAuthData: null,
      goodpayExpireAt: 0,
      gpFieldsToken: '',
      showCreditForm: true,
      selectedAliasId: '',
      //Google Wallet
      goodpayHasPaymentRequest: true,
      googlePayResponse: null,
      //Apple Wallet
      canMakePayments: false,
      applePayResponse: null,
      //Goodpay Common Wallet Data
      goodpayWalletExpireAt: 0,
      goodpayWalletAuthData: null,
      goodpayWalletTransaction: null,
      goodpayWalletTxToken: '',

      //paypal
      paypalOrderId: null,
      // paypalPreAuth: {},

      // paymentIntentAmount: -1,
      paymentIntentStatus: '',
      orderNumber: '',
      uniqueOrderId: '',

      //only calculated:
      pickupDate: {},
      // displayPickupDate: '',

      // timesInfoDialog: false,
      timesInfoDialog: false,
      customTipActive: false,
      tipType: 'none',
      tipPercent: 0,
      tipAmount: 0,
      inputTipAmount: 0,
      showTipContainer: false,
      showTipInputAnimation: false,
    }
  },

  watch: {
    tipAmount(newValue) {
      this.updateTotal();
    },
    inputTipAmount(newValue) {
      this.$nextTick(() => {
        let _v = '' + this.inputTipAmount;
        if (_v) {
          _v = _v.replaceAll(',', '.');
          console.log('ddddddddddddddd inner value ' + _v);
          let v = parseFloat(_v);
          if (v && v < 0) {
            v = 0;
            this.inputTipAmount = 0;
          }
          if (this.tipAmount !== v) {
            this.tipAmount = 0 + v;
          }
        }
      });
    },
    goodpayWalletAuthData(newValue) {
      console.log('watched authData has been set to ' + newValue);
    },
    // currentStep(newValue){
    //     if(newValue === 2){
    //
    //     }
    // }
    // sameAsInvoiceAddress(newValue) {
    //     if (this.step1Ok) {
    //         this.step1Error = '';
    //     }
    // },

    // autoModel(newValue) {
    //     if (newValue.obj) {
    //         this.$ls.set('selectedStore', JSON.stringify(newValue.obj));
    //         store.getters.selectedStore = newValue.obj;
    //         store.commit('selectedStore', util.cloneMe(newValue.ob));
    //         // this.updateMinOrderAmount();
    //     }
    // },

    // daySelected(newValue) {
    //     if (newValue === '1') {
    //         this.preselectDay1();
    //     } else if (newValue === '2') {
    //         this.preselectDay2();
    //     } else {
    //         this.time = '';
    //     }
    // },

    // consentB(newValue) {
    //     if (newValue && this.consentA) {
    //         this.currentStep = 4;
    //     }
    // },
    // consentA(newValue) {
    //     if (newValue && this.consentB) {
    //         this.currentStep = 4;
    //     }
    // },


    time(newValue) {
      if (newValue && newValue.utc) {
        this.$ls.set('selectedTime', newValue);
        //         store.commit('selectedTime', util.cloneMe(newValue));
      }
    }

  },

  computed: {
    secureTip() {
      let t = this.tipAmount;
      if (t && t >= 0) {
        let rounded = roundToTwo(t);
        return rounded;
      }
      return 0;
    },
    tipConfig() {
      return cloneMe(qconst.tipConfig);
    },
     totalSavedByDiscounts(){
      return roundToTwo(store.getters.appliedDiscounts.reduce((sum, d) => sum + d.absoluteAmount, 0));
    },
    showGpSubmit() {
      return this.selectedAliasId && this.paymentMethods.length > 0;
    },
    showCustomerCard() {
      // try {
      //   return store.getters.bbnUser.primaryCardId.length > 0
      //     && !!store.getters.cards.find(c => c.rfid === store.getters.bbnUser.primaryCardId)
      //       .accounts.find(a => a.accountType === 'CRED');
      // } catch (e) {
      return false;
      // }
    },
    step1Ok() {
      if (this.selfServiceEnabled) {
        let nameError = util.getName1Error(this.name);
        if (nameError) {
          this.step1Error = nameError
          return false;
        }
      }

      // if (this.name.length < 4 || this.name.indexOf(' ') < 2) {
      //     this.step1Error = 'Bitte Vor- und Nachname eingeben';
      //     return false;
      //     // } else {
      //     //     let nn = this.name.substring(this.name.indexOf(' ') + 1, this.name.length);
      //     //     if (nn.length < 2) {
      //     //         this.step1Error = 'Bitte Vor- und Nachname eingeben';
      //     //         return false;
      //     //     }
      // }

      // if (this.email) {
      this.email = util.removeSpaces(this.email);
      if (!util.isEmailOk(this.email)) {
        this.step1Error = 'Die E-Mail Addresse ist ungültig';
        return false;
      }
      // }

      // if (this.selfServiceEnabled && !this.checkMobilnummer()) {
      //   this.step1Error = 'Die eingegebene Mobilnummer ist ungültig';
      //   return false;
      // }

      // //InvoiceAddress
      // //street
      // if (this.invoiceAddress.street.length < 4) {
      //     this.step1Error = 'Die Straße ist erforderlich';
      //     return false;
      // }
      //
      // if (this.invoiceAddress.street.length > 0 && (/\d/.test(this.invoiceAddress.street) === false)) {
      //     this.step1Error = 'Die Hausnummer fehlt';
      //     return false;
      // }
      //
      // //validate plz
      // if (this.invoiceAddress.plz.length < 4) {
      //     this.step1Error = 'Die Postleitzahl ist erforderlich';
      //     return false;
      // }
      // let plz = util.removeSpaces(this.invoiceAddress.plz);
      // if (isPlzOk(plz) === false) {
      //     this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
      //     return false;
      // }
      // if (plz.length < 4) {
      //     this.step1Error = 'Die Postleitzahl ist zu kurz';
      //     return false;
      // }
      //
      // //city
      // if (this.invoiceAddress.city.length < 3) {
      //     this.step1Error = 'Der Ort ist erforderlich';
      //     return false;
      // }

      // if (!this.sameAsInvoiceAddress) {
      //     //deliveryAddress
      //     if (this.deliveryAddress.street.length < 4) {
      //         this.step1Error = 'Die Straße ist erforderlich';
      //         return false;
      //     }
      //
      //     if (this.deliveryAddress.street.length > 0 && (/\d/.test(this.deliveryAddress.street) === false)) {
      //         this.step1Error = 'Die Hausnummer fehlt';
      //         return false;
      //     }
      //
      //     //validate plz
      //     if (this.deliveryAddress.plz.length < 4) {
      //         this.step1Error = 'Die Postleitzahl ist erforderlich';
      //         return false;
      //     }
      //     let plz = this.deliveryAddress.plz.trim();
      //     if (isPlzOk(plz) === false) {
      //         this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
      //         return false;
      //     }
      //     if (plz.length < 4) {
      //         this.step1Error = 'Die Postleitzahl ist zu kurz';
      //         return false;
      //     }
      //
      //     //city
      //     if (this.deliveryAddress.city.length < 3) {
      //         this.step1Error = 'Der Ort ist erforderlich';
      //         return false;
      //     }
      // }
      this.step1Error = '';
      return true;
    },
    abholadresse() {
      return '';
      // return this.$options.filters.displayFiliale(store.getters.selectedStore);
    },
    asGuest() {
      return store.getters.loggedIn === false;
    },

    selfServiceEnabled() {
      return this.$store.getters.selfServiceEnabled;
    },

    // displayTomorrow() {
    //     let tomorrow = util.addDays(util.getCurrentRemoteTime(), 1);
    //     return this.$options.filters.weekDayMonth(tomorrow.getTime(), true);
    //
    //     // let d = tomorrow.toLocaleString();
    //     // return d.substring(0, d.indexOf(','));
    // },

    userSelectedHeute() {
      return this.selectedAbholDatum.value === 'Heute';
    },

    chooseCustomercard() {
      setGlobalKeyValue('chooseCustomercard', true);
      this.$store.commit('selectedDialog', 'Karten');
      this.$store.commit('showDialogContainer', true);
      // ebus.$emit('goto', {name: 'Karten'})
    },

    paymentMethods() {
      let pms = store.getters.paymentMethods;
      // if (!this.selectedAliasId && pms.length > 0) {
      //   this.preselectCreditCard();
      // }
      return pms;
    },

    // autocompleteStores() {
    //     let allstores = util.cloneMe(store.getters.stores);
    //     let model = [];
    //     for (let store of allstores) {
    //         model.push(
    //             {
    //                 displayName: store.strasse + ', ' + store.plz + ' ' + store.ort,
    //                 obj: store
    //             });
    //     }
    //     return model;
    // },

    // displayLieferwunsch() {
    //     if (this.daySelected === 'asap') {
    //         return 'So schnell wie möglich';
    //     } else if (this.daySelected === '1') {
    //         return 'Vorbestellung Heute';
    //     } else if (this.daySelected === '2') {
    //         return 'Vorbestellung Morgen';
    //     }
    //     return '';
    // }
  },

  beforeMount() {
    if (!this.checkEnter()) {
      return;
    }
    checkoutUtil.reset();
    let theTotal = this.$ls.get('theTotal');
    if (theTotal) {
      this.paymentRequestTotal = theTotal;
    }

    this.updateTotal();

    this.updateTipPercent('none'); //default tip
    this.inputTipAmount = 0 + this.tipAmount;

    let itemsString = JSON.stringify(store.getters.cartItems);
    try {
      let itemsHash = new Hashes.SHA256().hex(itemsString);
      if (itemsHash === this.$ls.get('lastItemsHash')) {
        console.log('use the same clientId');
        // this.$ls.set('clientId', util.generateClientId());
      } else {
        console.log('generate a new clientId');
        this.$ls.set('lastItemsHash', itemsHash);
        this.$ls.set('clientId', util.generateClientId());
      }
    } catch (e) {
    }
  },

  activated() {
    this.init('activated');
  },

  created() {
    ebus.$on('goodpayTxRedirect', () => {
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadEaserGpTxRedirect');
      if (!easer || now - parseInt(easer) > 5 * 1000) {
        setGlobalKeyValue('loadEaserGpTxRedirect', now);
      } else {
        //eased
        return;
      }
      this.safeUnload(6);
      console.log('goodpayTxRedirect..');
      store.commit('showDialogContainer', false);
      removeGlobalKey('ccRedirectUrl');
      let authData = this.goodpayCreditAuthData;
      if (authData) {
        this.goodpayTxAuthroize(this, store, authData, false);
      }
    });

    ebus.$on('goodpayWalletTxRedirect', () => {
      console.log('received event goodpayWalletTxRedirect');
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadEaserGpWalletRedirect');
      if (!easer || now - parseInt(easer) > 5 * 1000) {
        setGlobalKeyValue('loadEaserGpWalletRedirect', now);
      } else {
        //eased
        return;
      }
      this.safeUnload(6);
      console.log('goodpayWalletTxRedirect..');
      store.commit('showDialogContainer', false);
      removeGlobalKey('ccRedirectUrl');
      this.$nextTick(() => {
        let authData = this.goodpayWalletAuthData;
        if (authData) {
          this.goodpayTxAuthroize(this, store, authData, true);
        } else {
          console.log('goodpayWalletTxRedirect authData is null');
          ebus.$emit('throwError', getErrorDetails('goodpayWalletTxRedirect authData is null'));
          ebus.$emit('toast', 'Authorization was canceled');
        }
      });
    });

    ebus.$on('gpPaymentMethodSelected', (pm) => {
      if (!this.fromCheckout) {
        return;
      }
      this.removeFromCheckout();
      this.preselectCreditCard(pm);
      store.commit('secondSelectedDialog', '');
      store.commit('showDialogContainer', false);
      util.delayScroll('paymentRadios');
    });

    ebus.$on('closedDialogContainer', (dialogName) => {
      if (dialogName === 'PaymentMethods') {
        if (!this.fromCheckout) {
          return;
        }
        this.removeFromCheckout();
        let gpAddedPaymentMethod = getGlobalValue('gpAddedPaymentMethod');
        if (gpAddedPaymentMethod) {
          this.preselectCreditCard(gpAddedPaymentMethod);
          store.commit('secondSelectedDialog', '');
        } else {
          setTimeout(() => {
            this.preselectCreditCard();
          }, 1000);
        }
      }
    });

    ebus.$on('appconfigLoaded', () => {
      // if (this.timesToday.length === 0) {
      this.init('appconfigLoaded');
      // }
    });
  },

  mounted() {
    this.preInit();

    appleCanMakePayments().then((can) => {
      console.log('appleCanMakePayments response can = ' + (!!can));
      this.$nextTick(() => {
        this.canMakePayments = !!can || !PROD_ENV;
      });
    });

    this.$nextTick(() => {

      if (!bootstrap.getBtaste()) {
        window.location.reload();
        return;
      }

      if (this.asGuest && this.$store.getters.enableStempel) {
        ebus.$emit('toast', 'Bitte melde dich an, um Punkte für deine Stempelkarte zu sammeln');
      }

      // this.initDefaultDatePicker();
      // this.updateAllowedTimes();

      if (this.$ls.get('continueCheckout')) {
        let t = this.$ls.get('selectedTime');
        if (t) {
          this.time = util.cloneMe(t);
        }
      }

      ebus.$emit('loadAppconfig');
      store.state.hideScroll = true;
      this.captchaInput = '';
      // store.commit('showLoading', false);

      this.updateInterval = setInterval(() => {
        ebus.$emit('loadAppconfig');
      }, 30 * 1000);

      //only for online payment
      if (this.$ls.get('continueCheckout', false)) {
        this.$ls.remove('continueCheckout');
        // this.finishStep1();
        // if (this.time !== null) {
        //     let ea = this.calcEarliestAbholung();
        //     if (this.time.utc >= ea.getTime()) {
        //         //already selected time is till valid, so lets go to payment directly
        setTimeout(() => {
          this.psp = 'credit';
          this.finishStep1();
        }, 200);
        // } else {
        //     this.time = null;
        // }
        // }
      }
    });
  },

  destroyed() {
    this.safeUnload();
    checkoutUtil.reset();

    util.clearEvents([
      'goodpayTxRedirect',
      'goodpayWalletTxRedirect',
      'goodpayGoogleTxRedirect',
      'gpPaymentMethodSelected',
      'closedDialogContainer',
      'appconfigLoaded',
    ]);

    store.commit('removeSpecialCartItem', 'specialUniqueOnlineServiceFee');

    try {
      document.head.removeChild(recaptchaScript);
    } catch (e) {

    }

    store.state.hideScroll = false;
    // this.earlyClientSecret = '';
    this.clientSecret = '';
    this.order = {};
    this.usingPaymentRequest = false;
    this.paymentIntentId = '';
    // this.creditPreAuth = {};
    // this.paypalPreAuth = {};
    // document.getElementById('paypal-button-container').innerHTML = '';
    this.currentStep = 1;

    // this.paymentRequestCreated = false;

    util.clearTheInterval(this.updateInterval);

  },

  methods: {
    refreshForm() {
      if (isIos()) {
        this.showForm = false;
        setTimeout(() => {
          this.showForm = true;
        }, 400);
      }
    },
    resetValidation() {
      this.$nextTick(() => {
        this.$refs.inhouseMpDataForm.resetValidation();
        this.refreshForm()//Bugfix for https://github.com/vuetifyjs/vuetify/issues/11942
      });
    },
    validate() {
      try {
        return this.$refs.inhouseMpDataForm.validate()
      } catch (e) {
        return false;
      }
    },
    updateName(v) {
      this.$nextTick(() => {
        this.name = v;
      });
    },
    updateEmail(v) {
      this.$nextTick(() => {
        this.email = v;
      });
    },
    updatePhone(v) {
      this.$nextTick(() => {
        this.phone = v;
      });
    },
    setFromCheckout() {
      setGlobalKeyValue('fromCheckout', true)
      this.fromCheckout = true;
    },
    removeFromCheckout() {
      removeGlobalKey('fromCheckout');
      this.fromCheckout = false;
    },
    async onApplePaymentButtonClicked() {
      if (this.isMissingAgbs()) {
        return;
      }

      let self = this;
      this.safeUnload(30);

      let label = "Bestellung bei " + store.state.brandName;
      let amount = (0 + this.total);

      // if (false) {
      if (window.PaymentRequest) {
        const data = await createApplePayPaymentRequest(
            // cartData.products.map((item) => {
            //   return {label: item.name, amount: item.amount};
            // }),
            label,
            amount,
        )
            .show()
            .then(function (response) {
              console.log('applepay response from paymentRequest: ' + JSON.stringify(response));
              // Dismiss payment dialog.
              response.complete('success');
              return response
            })
            .catch((err) => {
              self.stopLoading();
              let e = 'Code TAPR'; //takeaway applepay payment request

let errorDetails = getErrorDetails(err);
            if (errorDetails) {
              e += ' - ' + errorDetails;
            }
  //takeaway applepay payment request
              self.notifyError(e);
              self.stopLoading();
              ebus.$emit('throwError', getErrorDetails(err, 'CheckoutInhouseMitOnlinePaymentTip', ' error=' + e));
              // alert('show() error! ' + err.name + ' error: ' + err.message);
            });
        let tokenJson = data.details.token.paymentData;
        console.log('applepay tokenJson from paymentRequest: ' + JSON.stringify(tokenJson));
        self.handleApplePaymentToken(self, tokenJson);
        return true;
      } else {
        const data = await performApplePayPayment(
            // cartData.products.map((item) => {
            //   return {label: item.name, amount: item.amount};
            // }),
            label,
            amount,
        )
            .then(function (response) {
              console.log('applepay response from ApplePayJs: ' + JSON.stringify(response));
              return response
            })
            .catch((err) => {
              self.stopLoading();
              let e = 'Code TAJS'; //takeaway applepay apple Js
              self.notifyError(e);
              self.stopLoading();
              ebus.$emit('throwError', getErrorDetails(err, 'CheckoutInhouseMitOnlinePaymentTip', ' error=' + e));
              // alert('show() error! ' + err.name + ' error: ' + err.message);
            });
        let tokenJson = data.token.paymentData;
        console.log('applepay payment token from ApplePayJs: ' + JSON.stringify(tokenJson));
        self.handleApplePaymentToken(self, tokenJson);
        return true;
      }


      // performPayment(
      //   currency_code,
      //   cartData.products.map((item) => {
      //     return {label: item.name, amount: item.amount};
      //   }),
      //   label,
      //   amount,
      // )
      //   .then((paymentStatus) => {
      //     switch (paymentStatus) {
      //       case PaymentStatus.CANCEL:
      //         console.log('Payment cancel')
      //         alert('Payment cancel');
      //         break;
      //       case PaymentStatus.SUCCESS:
      //         console.log('Payment success')
      //         alert('Payment success');
      //         break;
      //       default:
      //         console.log('Payment fail ' + paymentStatus);
      //         alert('Payment fail');
      //         break;
      //     }
      //   })
      //   .catch((err) => {
      //     console.log('error in performPayment ', err);
      //   });
    },
    async googlePaymentClicked(type) {
      if (this.isMissingAgbs()) {
        return;
      }

      let self = this;
      this.safeUnload(30);

      const responseShow = document.getElementById('response');
      if (responseShow) {
        while (responseShow.firstChild) {
          responseShow.removeChild(responseShow.firstChild);
        }
      }
      let methods = []
      // add method support for google pay
      if (type === 'google-pay') {
        methods.push({
          supportedMethods: 'https://google.com/pay',
          data: this.getGooglePaymentsConfiguration()
        })
      }

      //remember the total of the paymentRequest to be able to detect changes of the total
      self.paymentRequestTotal = (0 + this.total);

      const details = {
        total: {
          label: "Bestellung bei " + store.state.brandName,
          amount: {currency: "EUR", value: '' + this.paymentRequestTotal}
        },
        // displayItems: [
        //   {
        //     label: "Bestellung zur Abholung",
        //     amount: { currency: "EUR", value: "110" },
        //   },
        // ],
        // shippingOptions: [
        //   {
        //     id: "standard",
        //     label: "Standard shipping",
        //     amount: { currency: "EUR", value: "10" },
        //     selected: true,
        //   },
        // ],
      };
      if (window.PaymentRequest) {
        self.goodpayHasPaymentRequest = true;
        const data = await this.createGooglePaymentRequest(methods, details)
            .show()
            .then(function (response) {
              // Dismiss payment dialog.
              response.complete('success');
              return response
            })
            .catch((err) => {
              self.stopLoading();
              let e = 'Code TGPC'; //takeaway google payment clicked
              console.log(e + ' error: ' + (err && err.constructor === Object ? JSON.stringify(err) : err));
              // self.notifyError(e);
              ebus.$emit('throwError', getErrorDetails(err, 'CheckoutInhouseMitOnlinePaymentTip', ' error=' + e));
              // alert('show() error! ' + err.name + ' error: ' + err.message);
            });
        console.log('data response: ' + (typeof data) + ' .... ' + data);
        if (data) {
          self.handleGooglePaymentResponse(self, data)
        }
        return true
      } else {
        self.goodpayHasPaymentRequest = false;
        self.stopLoading();
        console.log('PaymentRequest API is not available.');
        // alert('Google Pay is not available on this browser. Please use the application in Chrome or Safari instead');
      }
    },
    /**
     * Define your unique  Pay API configuration
     *
     * @returns {object} data attribute suitable for PaymentMethodData
     * https://developers.google.com/pay/api/android/reference/request-objects
     */
    getGooglePaymentsConfiguration() {
      return {
        environment: goodpayUtil.walletEnvironment,
        apiVersion: 2,
        apiVersionMinor: 0,
        merchantInfo: {
          // a merchant ID is available for a production environment after approval by Google
          // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist
          // https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist
          merchantId: googlePayMerchantId,
          merchantName: store.state.brandName,
        },
        // transactionInfo: {
        //   totalPriceStatus: 'FINAL',
        //   totalPrice: '12.34',
        //   currencyCode 'EUR',
        // },
        shippingAddressRequired: false,
        allowedPaymentMethods: [{
          type: 'CARD',
          parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              'gateway': goodpayUtil.googleGateway,
              'gatewayMerchantId': goodpayUtil.googleGatewayMerchantId,
            }
          }
        }],
        transactionInfo: getGoogleTransactionInfo(this.total),
      };
    },
    /**
     * Create a PaymentRequest
     *
     * @returns {PaymentRequest}
     */
    createGooglePaymentRequest(methods, details) {
      // options: add additional requirements for payment
      try {
        const options = {
          // requestPayerEmail: true,
          // requestPayerName: true,
          requestShipping: false,
        };
        let pr = new window.PaymentRequest(methods, details, options);
        console.log('Google PaymentRequest created successfully')
        return pr;
      } catch (error) {
        console.error('Error creating Google PaymentRequest:', error);
      }
    },
    // funtion create button google pay
    onGooglePayLoaded() {
      const paymentsClient = new google.payments.api.PaymentsClient();
      const self = this
      paymentsClient.isReadyToPay({
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [{
          type: 'CARD',
          parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks,
          },
        }],
      })
          .then(function (response) {
            if (response.result) {
              const button = paymentsClient.createButton({
                buttonColor: 'default',
                buttonType: 'buy', buttonRadius: 100,
                buttonLocale: 'de',
                buttonSizeMode: 'fill',
                onClick: {}
              });
              self.$refs.googlePay.appendChild(button);
            }
          })
          .catch(() => {
            console.log('PaymentRequest API not available.');
          });
    },
    /**
     * Process a PaymentResponse
     *
     * @param {PaymentResponse} response returned when a user approves the payment request
     */
    handleGooglePaymentResponse(self, response) {
      console.log('goodpay handleGooglePaymentResponse for response', response);
      self.googlePayResponse = util.cloneMe(response);
      // {
      //   "requestId": "d0cdea00-e453-42e9-b7f0-48ebfdc2eef2",
      //   "methodName": "https://google.com/pay",
      //   "details": {
      //   "apiVersionMinor": 0,
      //     "apiVersion": 2,
      //     "paymentMethodData": {
      //     "description": "Visa •••• 3011",
      //       "tokenizationData": {
      //       "type": "PAYMENT_GATEWAY",
      //         "token": "{\"signature\":\"MEUCIQCk4g1QnpcFQqLxW+CTyVKB7EAveB5/16DQJxOWGboKCwIgDPx6DDctNXfl2SSVtBzDZq/0+ZGPV9J5CZQ5ummXXag\\u003d\",\"intermediateSigningKey\":{\"signedKey\":\"{\\\"keyValue\\\":\\\"MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEUHBdbUz4HueZYZP4Y4oWx4fXTO+yLEr91hhAocs/BQc9aPf8DistFnaTmw2jw+TmlMYo5rU8BOO9AMV7HfYJ1Q\\\\u003d\\\\u003d\\\",\\\"keyExpiration\\\":\\\"1696795161828\\\"}\",\"signatures\":[\"MEUCIEp5SBgZkD1G8gfwWchaFo0++8AbWepjnmA2S4DA//AtAiEAxLZQDErzlB2P3WhH7whXXSj4FR4n/cy1/lQB4k8uMGw\\u003d\"]},\"protocolVersion\":\"ECv2\",\"signedMessage\":\"{\\\"encryptedMessage\\\":\\\"FEWe4VudkgM8Cn1Nk07FHjyrZKDeMZZU0krBZkELPWZCy+PG5UCnCWeKKezBtvfDWA0ihKkxB6n4ElKRJ4y04gjaXV3+xMukwqhSmmIhF0TNTMpZDFhSSCpgarlpKkW/9+wlmq9Obt3TpY73IXHqrQ8n9NaxyGoh3TMIrBjuWjxL2fucoNLoaYBGDIIsva1m4ouFGiGHkdMFew7IGVuwppgaQBx3XITqqI4jLeBlfeNr//2NAaaPec+UK6lkIfb4ar0ZC0ESaoql+KyOLVbfUgnynBr4A4WgxKFzee3rODW8HgxRVcwNHGpF8nkTYgtwTf8FhnpgnUGSbAeN3KYC/gQ/xyaWtmY+0vz40KNY6rMMB8E1YFcO5mD/Uink0TEIcSRw99W9g4CKPCHeNH4LUn8ZJIDg/00JD8iujbFr8TckRRNJlHNsFjVg4bcAY89uctAFcDEoaN7vQS4/KDHOkxbSUtPj/Pd5JSxj4D/0HRpQWA7mG+5WAAs6QMQnMqiKRLu+4W60eDBvAUV3ZrHpLs5kPYJvd7ecNs9Xhw5RwMpeSOIXrjs7wq3CS+7BY/DJsVEyijopKA\\\\u003d\\\\u003d\\\",\\\"ephemeralPublicKey\\\":\\\"BGYDAxb+aR5iNWWaRv0Rp0XOn820ggpZTOvzTcn3gL4kF8vSeEuWV9oI6lbFePh0WGRQLmyQUG3P/tWGiNzbsrY\\\\u003d\\\",\\\"tag\\\":\\\"Zmc4RbxQcT8Y7h1ilZUPOAwMv4tkPcvZ5xVC9s2llHI\\\\u003d\\\"}\"}"
      //     },
      //     "type": "CARD",
      //       "info": {
      //       "cardNetwork": "VISA",
      //         "cardDetails": "3011"
      //     }
      //   }
      // },
      //   "shippingAddress": null,
      //   "shippingOption": null,
      //   "payerName": null,
      //   "payerEmail": null,
      //   "payerPhone": null
      // }
      console.log('goodpay GooglePay formattedResponse', response.toJSON());
      // const formattedResponse = document.createElement('pre');
      // let d = JSON.stringify(response.toJSON(), null, 2);
      // formattedResponse.appendChild(document.createTextNode(d));
      // document.getElementById('GoogleResponse')
      //   .appendChild(formattedResponse);

      //https://developers.google.com/pay/api/web/reference/response-objects#PaymentData
      let googlePayToken = response.details.paymentMethodData.tokenizationData.token;
      console.log('goodpay googlePayToken: ' + googlePayToken);

      //for development/sandbox we need to get the token from the simulator

      self.initGoodpayWalletTx(googlePayToken, false, true);
    },

    handleApplePaymentToken(self, token) {
      self.initGoodpayWalletTx(token, true, false);
    },

    // async submitGoodpayCreditFieldsTokenToPsp(token) {
    //   let self = this;
    //   self.commit('showLoading', true);
    //   // https://docs.saferpay.com/home/integration-guide/licences-and-interfaces/saferpay-fields#saferpay-fields-initialization
    //   let msg = {
    //     action: action$GoodpayFrontendApi,
    //     method: 'submitFieldsTokenToPsp',
    //     data: {
    //       fieldsToken: token,
    //     },
    //   };
    //   await xhr.xhrSend(true, msg, (reply) => {
    //     self.commit('showLoading', false);
    //     if (reply.ok && reply.response && reply.response.ok) {
    //       console.log('goodpay submitgGodpayCreditTokenToPsp was ok: ' + JSON.stringify(reply));
    //     } else {
    //       console.log('goodpay submitgGodpayCreditTokenToPsp error: ' + JSON.stringify(reply));
    //     }
    //   });
    // },

    isMissingAgbs() {
      if (!this.accceptedAgbs) {
        ebus.$emit('toast', 'Bitte zuerst unsere AGBs akzeptieren');
        return true;
      }
      return false;
    },

    submitCc() {
      if (this.isMissingAgbs()) {
        return;
      }
      //init transaction with aliasId
      this.initGoodpayCreditTx();
    },

    // submitCc() {
    //   // submit(); sends the entered hosted fields data to Saferpay.
    //   // store payment means data
    //   this.safeUnload();
    //   let self = this;
    //   SaferpayFields.submit({
    //     // https://docs.saferpay.com/home/integration-guide/licences-and-interfaces/saferpay-fields#saferpay-fields-initialization
    //     onSuccess: function (e) {
    //       //Callback on successful Submit
    //       // Once the onSuccess event is called, you need to forward the Saferpay Fields token to your server-backend,
    //       // in order to initialize the next step (see above) and also gather the RedirectUrl, to perform things like
    //       // 3D Secure and/or DCC. How you move the token to the backend is completely up to you. You can provide the
    //       // onSuccess event with an AJAX-method, to execute the initialization in the background on a successful submit
    //       // and forward the RedirectUrl to the fronend for a redirect this way, which you then can open in an iframe,
    //       // Lightbox, or as a full redirect. However a redirect via GET, or POST, towards your initialize-script,
    //       // is also an option. Refer to the above mentioned chapters, to learn, how to initialize a transaction, or
    //       // just save a card, using a Saferpay Fields token.
    //       console.log('goodpay submitCc onSuccess Payment token = '" + e.token + "'');
    //       self.gpFieldsToken = e.token;
    //       self.submitGoodpayCreditFieldsTokenToPsp(self.gpFieldsToken);
    //     },
    //     onError: function (evt) {
    //       //Callback on unsuccessful Submit
    //       console.log('goodpay submitCc onError ' + JSON.stringify(evt));
    //       ebus.$emit('showInfo', {
    //         title: 'Die Kredikarte wurde nicht erkannt: ' + evt.message,
    //       });
    //     }
    //   });
    // },

    step2Ok() {
      this.step2Error = '';
      return true;
    },

    getUserInfo() {
      let result = {
        btaste: bootstrap.getBtaste(),
        fuid: firebaseUtil.getFuid(),
        name: '' + this.name,
        email: util.sanitizeEmail(this.email),
        phone: util.sanitizePhone(this.phone),
      };
      return result;
    },
    // toggleInvoiceAddress() {
    //   this.isInvoiceAddressVisible = !this.isInvoiceAddressVisible;
    // },
    // submitOrderWithCustomerCard(_this, _store) {
    //   console.log('submitOrderWithCustomerCard');
    //   _this.safeUnload();
    //   // let extend = {
    //   //   psp: isPayPal ? 'paypal': _this.psp,
    //   // }
    //   // Object.assign(paymentAuth, extend);
    //   let updates = {
    //     storno: false,
    //     sentToPos: false,
    //     useCustomerCard: true,
    //     // sentPaymentToPos: false,
    //     // authCompleted: true, //authCompleted may be true already by requires_capture state
    //     // authCompletedAt: Date.now(),
//authorisedTotal: 0 + _this.total,
    //     psp: 'customerCard',
    //     // captured: false,
    //     // paymentAuth: paymentAuth
    //   };
    //
    //   let finalOrder = Object.assign(util.cloneMe(_this.order), updates);
    //   _store.commit('updateOrder', finalOrder);
    //
    //   let order = util.cloneMe(_this.order);
    //   if (!order) {
    //     throw 'order not found for submitOrderWithCustomerCard';
    //   }
    //   let uniqueOrderId = order.uniqueOrderId;
    //   let updateOrder = {
    //     action: qconst.action$DocUpserter,
    //     collectionName: 'orders',
    //     updates: updates,
    //     subjectKey: {
    //       key: 'uniqueOrderId',
    //       value: uniqueOrderId
    //     },
    //     autoRetry: true,
    //   };
    //   xhr.xhrSend(true, updateOrder, (reply) => {
    //     if (reply && reply.ok) {
    //       console.log('single order successfully updated with useCustomerCard');
    //       _store.commit('deleteAllCartItems');
    //       _this.logPurchase();
    //       setTimeout(() => {
    //         setGlobalKeyValue('contextPostOrder', true);
    //         _this.$router.replace({
    //           name: 'Bestellung',
    //           params: {
    //             uniqueOrderId: uniqueOrderId
    //           }
    //         });
    //         ebus.$emit('showInfo', {
    //           title: 'Die Bestellung wurde erfolgreich übermittelt',
    //           text: ''
    //         });
    //       }, 1200);
    //     } else {
    //       console.log('single order reply not ok for customerCard');
    //       //retry
    //       console.log('retry submitOrderWithCustomerCard...');
    //       setTimeout(() => {
    //         _this.submitOrderWithCustomerCard(_this, _store);
    //       }, 800);
    //     }
    //   }, (err) => {
    //     //retry
    //     console.log('retry submitOrderWithCustomerCard...');
    //     setTimeout(() => {
    //       _this.submitOrderWithCustomerCard(_this, _store);
    //     }, 800);
    //   });
    // },
    markOrderAsAuthorized(isPayPal, paymentAuth, _this, _store) {
      console.log('markOrderAsAuthorized');
      _this.safeUnload();
      // let extend = {
      //   psp: isPayPal ? 'paypal': _this.psp,
      // }
      // Object.assign(paymentAuth, extend);
      let updates = {
        storno: false,
        sentToPos: false,
        sentPaymentToPos: false,
        authCompleted: true, //authCompleted may be true already by requires_capture state
        authCompletedAt: Date.now(),
        authorisedTotal: 0 + _this.total,
        isPayPal: isPayPal,
        psp: isPayPal ? 'paypal' : _this.psp,
        captured: false,
        paymentAuth: paymentAuth
      };

      if (qconst.withPosApi) {
        updates.posConfirmedTime = 0;
      }

      let finalOrder = Object.assign(util.cloneMe(_this.order), updates);
      _store.commit('updateOrder', finalOrder);

      let order = util.cloneMe(_this.order);
      if (!order) {
        throw 'order not found for markOrderAsAuthorized';
      }
      let uniqueOrderId = order.uniqueOrderId;
      let updateOrder = {
        action: qconst.action$DocUpserter,
        collectionName: 'orders',
        updates: updates,
        subjectKey: {
          key: 'uniqueOrderId',
          value: uniqueOrderId
        },
        autoRetry: true,
      };
      xhr.xhrSend(true, updateOrder, (reply) => {
        if (reply && reply.ok) {
          console.log('single order successfully updated with paymentAuth');

          const checkoutItems = cloneMe(store.getters.cartItems);
          ebus.$emit('fastUpdateInventory', checkoutItems);

          _store.commit('deleteAllCartItems');
          _this.logPurchase();
          _this.$ls.remove('userSelectedTargetTime');
          setTimeout(() => {
            setGlobalKeyValue('contextPostOrder', true);
            _this.$router.replace({
              name: 'Bestellung',
              params: {
                uniqueOrderId: uniqueOrderId
              }
            });
            ebus.$emit('showInfo', {
              title: 'Die Zahlung wurde erfolgreich abgeschlossen',
            selfClosing: true,
              text: ''
            });
          }, 1200);
        } else {
          console.log('single order reply not ok for paymentAuth');
          //retry
          console.log('retry markOrderAsAuthorized...');
          setTimeout(() => {
            _this.markOrderAsAuthorized(isPayPal, paymentAuth, _this, _store);
          }, 800);
        }
      }, (err) => {
        //retry
        let eMsg = 'retry markOrderAsAuthorized...'
        console.log(eMsg);
        ebus.$emit('throwError', getErrorDetails(err, 'CheckoutInhouseMitOnlinePaymentTip', eMsg));
        setTimeout(() => {
          _this.markOrderAsAuthorized(isPayPal, paymentAuth, _this, _store);
        }, 800);
      }, 15 * 1000);
    },
    _saveOrder(retryCount) {
      console.log('_saveOrder');
      if (!retryCount) {
        retryCount = 0;
      }
      let checkpoints = 0;
      try {
        this.safeUnload();
        let order;
        ++checkpoints;
        order = this.generateOrder();
        ++checkpoints;

        let msg = {
          action: qconst.action$SaveNewOrder,
          order: order,
          // captchaText: '' + this.captchaInput
        };

        let timeout = qconst.withPosApi ? (60 * 1000) : (10 * 1000);
        xhr.xhrSend(true, msg, (reply) => {
          //either ok with orderId or notOk
          store.commit('showLoading', true);
          ++checkpoints;
          console.log('??? SaveNewOrder reply OK = ' + !!reply.ok);
          if (reply.ok) {
            ++checkpoints;
            this.order = reply;
            this.currentStep = 3;
            util.delayScroll('paymentRadios');
            setTimeout(() => {
              this.startPaymentProcess();
            }, 400);

            // this.$ls.set('lastOrder', order);
            // // ebus.$emit('orderSuccess');
            //
            // // this.logPurchase();
            // ++checkpoints;
            // store.commit('deleteAllCartItems');
            // ++checkpoints;
            // this.$router.replace({name: 'Bestellung', params: {uniqueOrderId: order.uniqueOrderId}});
            // this.$router.replace({name: 'Bestaetigung'});
          } else {
            if (reply.captchaError || reply.secTokenError) {
              ebus.$emit('forceReload');
              // this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
            } else if (reply.forceReload) {
              alert('Hinweis: Nach einer kurzen Aktualisierung der App, die automatisch durchgeführt wird,' +
                  ' kannst du deine Bestellung abschließen.');
              ebus.$emit('forceReload');
            } else {
              checkpoints += 300;
              // if (reply.captchaError) {
              //     checkpoints += 200;
              //     this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
              // } else {
              // checkpoints += 300;
              this.notifyError('Fehler bei der Verarbeitung der Bestellung', 'Bitte versuche es erneut');
              ebus.$emit('pullBuyersProfile');
              // }
              // this.reloadCaptcha();
              // checkpoints += 10000;

              // store.commit('showLoading', false);
              //
              ebus.$emit('throwError', getErrorDetails('Error in save new order inhouse, checkpoints: ' + checkpoints));
            }
          }
        }, (err) => {
          checkpoints += 20000;
          ebus.$emit('throwError', getErrorDetails('Transport error in save new order inhouse; checkpoints: ' + checkpoints + ' retryCount: ' + retryCount + ' error:' + err.message));
          //this.notifyError('Fortschritt ' + retryCount + 1 + '/' + 5, '');

          if (!retryCount || retryCount < 2) {
            //retry
            let r = ++retryCount;
            setTimeout(() => {
              this._saveOrder(r);
            }, 2200);
          } else {
            // store.commit('showLoading', false);
            this.notifyError('Verbindungsfehler', 'Bitte versuche es direkt nochmal');
            console.log('Error Verbindungsfehler');
            // setTimeout(() => {
            //     ebus.$emit('reload', true)
            // }, 2500);
          }
        }, timeout);
      } catch (e) {
        checkpoints += 30000;
        ebus.$emit('throwError', getErrorDetails('Exception in save new order inhouse: ' + e.message + '; checkpoints: ' + checkpoints));
        console.log('!!!!! error: ' + e.message);
      }
    },
    startPaymentProcess() {
      // alert('startPaymentProcess...');
      this.safeUnload();
      console.log('Save order was ok, startPaymentProcess now...');
      this.showSubmitButton = true;

      if (enableGoodpay) {
        if (!this.goodpayScriptCreated) {
          this.goodpayScriptCreated = true;
          // Import the Google Pay library to create a button.
          recaptchaScript = document.createElement('script');
          recaptchaScript.setAttribute(
              "src",
              "https://pay.google.com/gp/p/js/pay.js"
          );
          recaptchaScript.async = true;
          document.head.appendChild(recaptchaScript);
          setTimeout(() => this.onGooglePayLoaded(), 1500);
        }

        this.preselectCreditCard();
      }

      this.lazyCreatePaymentRequests(); // both paypal and goodpay

      setTimeout(() => {
        this.currentStep = 3;
        this.stopLoading();
      }, 400);

      // util.delayScroll('paymentRadios');
    },
    preInit() {
      if (this.checkEnter()) {
        if (store.state.onlineServiceFee) {
          let item = {
            id: 'specialUniqueOnlineServiceFee',
            articleNo: '',
            posId: '5007',
            // delay: this.selectedCat.delay,
            cartItemId: util.generateClientId(),
            isOffer: false,//!!(size.offerId), //offers and cartItems ar always size specific
            type: qconst.type$generic,
            nameToDisplay: 'Online Servicegebühr',//itemClone.nameDE,
            description: '',// + itemClone.descriptionDE,
            // days: itemClone.days,
            notes: '',
            // gramm: itemClone.gramm,
            // unikat: !!(itemClone.unikat),
            sizePrice: store.state.onlineServiceFee,// sizePrice,
            sumOfExtras: 0,// sizePrices.sumOfExtras,// this.total - (size.price * size.aaaCount),
            itemTotal: store.state.onlineServiceFee,//sizePrices.sizeTotal + sizePrices.sumOfExtras,
            count: 1,
            vol: '',//size.vol,
            extras: [
              // {name:'',price:0}
            ],
            extrasToDisplay: [], //['eins', 'zwe' ] //or empty array
            variantsSelected: [], //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
            stylesSelected: [] //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
          };
          store.commit('addItemToCart', {
            item: item, addSilent: true
          });
        }

        // util.jumpToTop();
        this.init();
        // firebaseUtil.gevent('begin_checkout', {
        //     currency: 'EUR',
        //     value: this.total,
        //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems))
        // });
      }
    },
    phoneKeydown(e) {
      util.phoneKeydown(e);
    },
    hideToolbar() {
      store.commit('hideToolbar', true);
    },
    unhideToolbar() {
      store.commit('hideToolbar', false);
    },
    clickRadio() {
      util.delayScroll('paymentRadios');
    },
    preselectCreditCard() {
      let pMethods = this.paymentMethods;
      // let pMethods =  util.cloneMe(store.getters.paymentMethods);
      if (pMethods && pMethods.length > 0) {
        this.selectMethod(pMethods[0]);
      }
    },

    showLieferzeiten() {
      this.timesInfoDialog = true;
    },

    // handleScrollingInStep2() {
    //     util.delayScroll('hintStep2');
    // },

    handleScrollingInStep3() {
      // util.delayScroll('paymentRadios');
    },

    clickZeroTip() {
      this.customTipActive= false;
      this.tipType = 'none';
      this.tipPercent = 0;
      let newSum = util.roundToTwo(store.getters.payerSum + (store.getters.payerSum * this.tipPercent / 100));
      let amount = util.roundToTwo(newSum - store.getters.payerSum);
      this.tipAmount = amount;
      this.inputTipAmount = 0 + amount;
    },

    clickCustomTip() {
      this.customTipActive = true;
      this.tipType = 'none';
      this.anim();
    },
    updateTipPercent(type) {
      this.customTipActive= false;
      this.tipType = type;
      this.tipPercent = 0 + (this.tipConfig[type] || 0);
      let newSum = util.roundToTwo(store.getters.payerSum + (store.getters.payerSum * this.tipPercent / 100));
      let amount = util.roundToTwo(newSum - store.getters.payerSum);
      this.tipAmount = amount;
      this.inputTipAmount = 0 + amount;
    },
    calcTipAmount(type) {
      let tip = 0;
      if (this.tipConfig[type]) {
        let newSum = util.roundToTwo(store.getters.payerSum + (store.getters.payerSum * this.tipConfig[type] / 100));
        tip = util.roundToTwo(newSum - store.getters.payerSum);
      }
      return tip;
    },
    roundUpTip() {
      let currentTotal = 0 + this.total;
      let newTotal = Math.ceil(currentTotal);
      console.log('dddddddddddd newTotal= ' + newTotal);
      let diff = util.roundToTwo(newTotal - store.getters.payerSum);
      this.tipAmount = diff;
      this.inputTipAmount = 0 + diff;
    },
    anim() {
      try {
        setTimeout(() => {
          let input = document.querySelector('.inputTipAmount');
          this.doTriggerAnimation(input);
        }, 50);
      } catch (err) {
        console.log('Error in animation: ' + err);
      }
    },
    doTriggerAnimation(elem) {
      if (elem) {
        elem.classList.remove('tipInputAnimation');
        elem.classList.add('tipInputAnimation');
        setTimeout(() => {
          elem.classList.remove('tipInputAnimation');
        }, 1250);
      }
    },


    updateTotal() {
      let t = this.secureTip;
      if (t && t > 0) {
        this.total = 0 + roundToTwo(store.getters.payerSum + t);
      } else {
        this.total = 0 + roundToTwo(store.getters.payerSum) - this.totalSavedByDiscounts;
      }
      this.totalWithoutTip = 0 + store.getters.payerSum;

      // if (this.usecase === 'delivery') {
      //     // let fee = 0;
      //     try {
      //         this.total = store.getters.payerSum + this.deliveryFee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // } else
      // if (this.usecase === qconst.usecase$delivery) {
      //     // let fee = 0;
      //     try {
      //         this.total = 0 + roundToTwo(store.getters.payerSum) + store.state.deliveryFee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // }
      // if (this.usecase === qconst.usecase$inhouse) {
      //     // let fee = 0;
      //     try {
      //         this.total = store.state.inhousePayerSum;//+ store.getters.selectedStore.fee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // }
    },

    // lazyCreateEarlyPaymentIntent() {
    //     if (this.earlyClientSecret.length > 0) {
    //         return;
    //     }
    //     let msg = {
    //         action: qconst.action$CreditCreateEarlyPaymentIntent,
    //         restaurantId: store.state.restaurantData.restaurantId,
    //         amount: this.total,
    //         userInfo: util.cloneMe(store.state.user),
    //         creditCustomerId: store.state.creditCustomerId,
    //         // aliasId: this.selectedAliasId
    //     };
    //     xhr.xhrSend(true, msg, (reply) => {
    //         if (reply.ok) {
    //             let paymentIntentId = reply.paymentIntentId;
    //             let clientSecret = reply.clientSecret;
    //             console.log('??? early paymentIntentId=' + paymentIntentId);
    //             console.log('??? early clientSecret=' + clientSecret);
    //             this.$nextTick(() => {
    //                 let status = reply.status;
    //                 // this.paymentIntentAmount = msg.amount;
    //                 this.earlyPaymentIntentId = paymentIntentId;
    //                 this.earlyClientSecret = clientSecret;
    //                 // this.paymentIntentStatus = status;
    //                 // this.orderNumber = reply.orderNumber;
    //                 // this.uniqueOrderId = reply.uniqueOrderId;
    //                 // this.createdAt = reply.createdAt; //server-side createdAt
    //
    //                 console.log('???status of early paymentIntent: ' + status);//requires_payment_method
    //
    //                 this.createPaymentRequest();
    //
    //                 // if (status === 'requires_action') {
    //                 //     this.handleRequiresAction();
    //                 // } else if (status === 'requires_capture') {
    //                 //     // this.notifyInfo('Die Zahlung wurde erfolgreich autorisiert');
    //                 //     this.saveOrder();
    //                 // } else {
    //                 //     this.notifyError('Unbekannter Status: ', status);
    //                 // }
    //             });
    //         }
    //     }, (err) => {
    //         console.log('??? error creating early intent: ' + err);
    //     })
    // },

    payPalOnApprove(_this, _store, _uid, data, actions) {
      console.log('PayPal payPalOnApprove completed successfully');
      // console.log('PayPal payPalOnApprove data: ' + JSON.stringify(data));
      // PayPal payPalOnApprove data: {"orderID":"9DH674709S118391F",
      //   "payerID":"SMW7RDDJZE8L6","paymentID":null,"billingToken":null,
      //   "facilitatorAccessToken":
      //   "A21AAL6ji2mvx-vZhPvr36iz-BMXBz6bTCFs8yWydRuGFbSG1C0cIVtSoFQoManvppZOYppJ_RzpIGnCnLOy7Mip2qT8kidiw",
      //     "paymentSource":"paypal"}
      _this.payPalAuthorizeFunction(_this, _store, _uid, data, actions);
    },

    payPalAuthorizeFunction(_this, _store, _uid, data, actions) {
      console.log('payPalAuthorizeFunction...');
      // PayPal Authorize the transaction
      _this.safeUnload();
      actions.order.authorize().then(function (authorization) {

        console.log('PayPal authorization completed successfully authorization: ' + JSON.stringify(
            authorization));

        // Get the authorization id
        let authorizationID = authorization.purchase_units[0]
            .payments.authorizations[0].id;
        let authorizationObjectId = authorization.id;

        console.log('!!!! paypal authorizationID: ' + authorizationID);
        console.log('!!!! paypal authorizationObjectId: ' + authorizationObjectId);

        //append authorizationID to the preAuth
        let paymentAuth = {
          paypalOrderId: _this.paypalOrderId,
          paypalAuthId: authorizationID,
          paypalAuthObjectId: authorizationObjectId,
        };
        // _this.paypalPreAuth.sellerAccountId = '' + paypalUtil.sellerAccountId;
        // console.log('??? _uid '+_uid);
        // console.log('??? _this.asGuest '+!!_this.asGuest);
        // _this.paypalPreAuth.btaste = _uid;
        // if (!_this.asGuest) {
        //   _this.paypalPreAuth.fuid = firebaseUtil.getFuid();
        // }
        // _this.paypalPreAuth.fuid = (_this.asGuest === true ? _uid : firebaseUtil.getUser().uid);
        // _this.approveId = approveId; // is always null??

        //paypalPreAuth contains
        // paypalOrderId,orderNumber,uniqueOrderId,createdAt,amount,paypalAuthId,sellerAccountId,fuid

        _this.markOrderAsAuthorized(true, paymentAuth, _this, _store);

        // Call your server to validate and capture the transaction
        // return fetch('/paypal-transaction-complete', {
        //     method: 'post',
        //     headers: {
        //         'content-type': 'application/json'
//                             },
        //     body: JSON.stringify({
        //         orderID: data.orderID,
        //         authorizationID: authorizationID
        //     })
//                         });
      }).catch(err => {
        _this.notifyError('PayPal Autorisierung fehlgeschlagen');
        _store.commit('showLoading', false);
        let e = 'PayPal onApprove inhouse mp: Error authorize paypal payment: ' + err.message;
        console.log(e);
        ebus.$emit('throwError', getErrorDetails(err, 'CheckoutInhouseMitOnlinePaymentTip', e));
      });
    },

    createPayPalOrderFunction(_this, _store, payPalTxDetails) {
      try {
        if (!checkoutUtil.wasPayPal1Invoked()) {
          checkoutUtil.setPayPal1Invoked(true);

          // createOrder: function (data, actions) {
          let msg = {
            action: qconst.action$CreatePayPalOrder,
            order: payPalTxDetails,
            negativeTest: false,
          };

          let cu = checkoutUtil;

          let p1 = new Promise((resolve, reject) => {
            new Promise((resolve2, reject2) => {
              resolve2('dummy');
            }).retryUntil((numTries) => {

              //msg.negativeTest = !msg.negativeTest;
              // msg.negativeTest = true; //simulate always fail

              console.log('createOrderFunction negativeTest = ' + msg.negativeTest);

              let p3 = new Promise((resolve3, reject3) => {
                _store.commit('showLoading', true);
                console.log('paypal createOrder... ');

                xhr.xhrSend(true, msg, (res) => {
                  setTimeout(() => {
                    cu.setPayPal1Invoked(false);
                  }, 3000);
                  console.log('paypal createOrder res: ', JSON.stringify(res));
                  cu.setPayPal1Invoked(false);
                  if (res.ok && res.data && res.data.paypalOrderId) {
                    console.log('paypal order created with orderId: ' + res.data.paypalOrderId +
                        ' numTries=' + numTries);
                    _this.$nextTick(function () {
                      _this.paypalOrderId = res.data.paypalOrderId;
                    });
                    resolve3({
                      status: 'success',
                      result: res.data.paypalOrderId
                    });
                  } else {
                    _store.commit('showLoading', false);
                    if (res.noLock) {
                      let info = 'Double execution prevented for CreatePayPalOrder inhouse mp';
                      console.log(info);
                      ebus.$emit('throwError', getErrorDetails(info));
                      resolve3({
                        errMessage: info
                      }); // triggers retry
                    } else {
                      let e = 'paypal error in createOrder inhouse mp; response: ' + JSON.stringify(res)
                          + ' numTries=' + numTries;
                      console.log(e);
                      resolve3({
                        errMessage: e
                      }); // triggers retry
                    }
                  }
                }, (err) => {
                  cu.setPayPal1Invoked(false);
                  let e = 'paypal createOrder err inhouse mp: ' + err.message + ' numTries=' + numTries;
                  console.log('fail createOrderFunction: ' + e);
                  resolve3({errMessage: e});// triggers retry
                }, 6100); //3 x 6100 plus 3 x 200 delay = 18900ms
              });
              return p3;
            }, 200, 3)
                .then((customFunctionResult) => {
                  console.log('final result: ' + customFunctionResult);
                  // final result: 9DH674709S118391F
                  _store.commit('showLoading', false);
                  resolve(customFunctionResult);
                }).catch((retryChainError) => {
              console.log('finalError: ' + retryChainError);
              _store.commit('showLoading', false);
              let e = 'paypal createOrder final error inhouse mp; ' + retryChainError;
              console.log(e);
              ebus.$emit('throwError', getErrorDetails(retryChainError, 'checkout', e));
              reject('failed after 3 tries');
              //retry no longer possible here
            });
          });
          return p1;

        } else {
          console.log('double event prevented payPal1');

        }
      } catch (e) {
        console.log('Error in createOrderFunction: ' + e.message);
        _store.commit('showLoading', false);
      }

    },

    lazyCreatePaymentRequests() {
      console.log('lazyCreatePaymentRequests...');

      if (enablePaypal) {
        //PayPal
        try {
          //https://developer.paypal.com/docs/api/orders/v2/#orders_create
          let payPalTxDetails = {
            intent: 'AUTHORIZE',
            // intent: 'authorize',
            payer: {
              name: {
                given_name: '',
                surname: ''
              },
              //@see https://developer.paypal.com/docs/api/orders/v2/#definition-phone_with_type.phone
              // phone: {
              //     phone_type: 'MOBILE',
              //     phone_number: {
              //         national_number: firebaseUtil.getUser().phoneNumber
              //     }
              // }
            },
            //https://developer.paypal.com/docs/api/orders/v2/#definition-purchase_unit_request
            purchase_units: [{
              description: 'Bestellung bei ' + store.getters.storeName,
              custom_id: '' + this.order.uniqueOrderId,
              invoice_id: '' + this.order.uniqueOrderId,
              amount: {
                currency_code: CURRENCY_CODE,
                value: '' + roundToTwo(this.total),//'1.00'
                breakdown: {
                  item_total: {
                    currency_code: CURRENCY_CODE,
                    value: '' + roundToTwo(this.total),
                  },
                  handling: {
                    currency_code: CURRENCY_CODE,
                    value: '0'
                  },
                  // shipping_discount: {
                  //     currency_code 'EUR',
//                                         value: '0'
                  // }
                }
              },
              // payee: {
              //     // email_address: firebaseUtil.getUser().email,
              //     merchant_id: paypalUtil.sellerAccountId,
//                                     },
              // shipping


              // "items": [
              //     {
              //         "name": "Levis 501 Selvedge STF",
              //         "unit_amount": {
              //             "currency_code": "EUR",
              //             "value": "25.00"
//                             },
              //         "quantity": "1"
//
              //     }
              // ],
              // "custom_id": "custom_value_{{$timestamp}}",
              // "invoice_id": "invoice_number_{{$timestamp}}",
              // "soft_descriptor": "Payment Camera Shop"


              // description: 'Gesamtbetrag',
              // // custom_id: firebaseUtil.getUser().uid,
              // soft_descriptor: '' + store.getters.storeName,
              // final_capture: false
            }],
            application_context: {
              brand_name: '' + store.state.brandName,
              shipping_preference: 'NO_SHIPPING'
              // shipping_preference: 'SET_PROVIDED_ADDRESS'
            },
            shipping_type: this.usecase === qconst.usecase$delivery ? 'SHIPPING' : 'PICKUP'
          };

          if (this?.name?.length) {
            let name = '' + this.name;
            if (name.trim().indexOf(' ') > 0) {
              let vorname = name.substring(0, name.indexOf(' '));
              let nachname = name.substring(name.indexOf(' '), name.length);
              payPalTxDetails.payer.name = {
                given_name: vorname,
                surname: nachname,
              };
            } else {
              payPalTxDetails.payer.name = {
                given_name: name,
              };
            }
          }


          // if (this.usecase === qconst.usecase$delivery || this.usecase === qconst.usecase$inhouse || this.usecase === qconst.usecase$taxi) {
          //     payPalTxDetails.application_context.shipping_preference = 'SET_PROVIDED_ADDRESS';
          let name = '';
          let address = {};
          let da = this.sameAsInvoiceAddress === true ? util.cloneMe(this.invoiceAddress) : util.cloneMe(this
              .deliveryAddress);
          //     if (this.usecase === qconst.usecase$takeAway) {
          //// S2S = ship to store
          //         name = 'S2S ' + store.getters.selectedStore.strasse + ' ' + store.getters.selectedStore.ort;
          //         address.street = '' + store.getters.selectedStore.strasse.trim();
          //         address.city = '' + store.getters.selectedStore.ort.trim();
          //         address.plz = '' + store.getters.selectedStore.plz.trim();
          //     } else {
          name = '' + this.name;
          address.street = da.street.trim();
          address.city = da.city.trim();
          address.plz = da.plz.trim();
          //     }

          // payPalTxDetails.purchase_units[0].shipping = {
          //     name: {
          //         full_name: name
//                         },
          //     // company: '' + this.deliveryAddress.company.trim(),
          //     // street: '' + this.deliveryAddress.street.trim(),
          //     // plz: '' + this.deliveryAddress.plz.trim(),
          //     // city: '' + this.deliveryAddress.city.trim(),
          //     address: {
          //         address_line_1: address.street,
          //         // address_line_2: '' + this.deliveryAddress.street.trim(),
          //         admin_area_2: address.city,
          //         // admin_area_1: '' + this.deliveryAddress.city.trim(),
          //         postal_code: address.plz,
          //         // address_line_1: '' + this.deliveryAddress.street.trim(),
//                     //         // address_line_2: '' + this.deliveryAddress.street.trim(),
          //         // admin_area_2: '' + this.deliveryAddress.city.trim(),
//                     //         // admin_area_1: '' + this.deliveryAddress.city.trim(),
          //         // postal_code: '' + this.deliveryAddress.plz.trim(),
          //         country_code: 'DE'
          //     }
          // }
//                                     } else {
          //     payPalTxDetails.application_context.shipping_preference = 'NO_SHIPPING';
//                                     }


          console.log('Paypal amount: ' + payPalTxDetails.purchase_units[0].amount.value);

          let _this = this;
          let _store = store;
          let _uid = bootstrap.getBtaste();

          //mount paypal button
          console.log('mount PayPal button...');
          //clear the button container first
          document.getElementById('paypal-button-container').innerHTML = '';
          // let cont = document.getElementById('paypal-button-container');
          // console.log('paypal-button-container = ',cont);
          // cont.innerHTML = '';
          console.log('Paypal payPalTxDetails: ' + JSON.stringify(payPalTxDetails));
          paypal.Buttons({
            // style: {
            //     layout: 'horizontal',
//                         },
            // Set up the transaction after the user clicked the PayPal button
            createOrder: async function () {
              if (_this.isMissingAgbs()) {
                return;
              }
              return _this.createPayPalOrderFunction(_this, _store, payPalTxDetails);
            },
            // Finalize the transaction
//                         onApprove: function (data, actions) {
            //     return actions.order.capture().then(function(details) {
            //         // Show a success message to the buyer
            //         alert('Transaction completed by ' + details.payer.name.given_name + '!');
//                                         });
//                         }

            // createOrder(data, actions) {
            //     // This function sets up the details of the transaction, including the amount and line item details.
            //     return actions.order.create(payPalTxDetails);
//                                 },
            onCancel: function () {
              store.commit('showLoading', false);
            },

            // https://developer.paypal.com/sdk/js/reference/#onapprove
            onApprove: function (data, actions) {
              if (!checkoutUtil.wasPayPal2Invoked()) {
                checkoutUtil.setPayPal2Invoked(true);
                setTimeout(() => {
                  checkoutUtil.setPayPal2Invoked(false);
                }, 3000);

                store.commit('showLoading', true);
                console.log('PayPal onApprove...');
                /*
                                  {orderID: "7A3177749P8522230", payerID: "5JJEW997VEN9G", facilitatorAccessToken: "A21AAHoer7Hkutbn5_oOD0PrE0KoB70gl3dNjwCEzvHvtRC_pGRMMtvy8xJL23D7hm1D3xi2m5fo4wNyHWb6icbo_xipQDQTA"}
      orderID: "7A3177749P8522230"
      payerID: "5JJEW997VEN9G"
      facilitatorAccessToken: "A21AAHoer7Hkutbn5_oOD0PrE0KoB70gl3dNjwCEzvHvtRC_pGRMMtvy8xJL23D7hm1D3xi2m5fo4wNyHWb6icbo_xipQDQTA..."
      }
                                 */
                /*
                                  {order: {…}, payment: null, subscription: {…}, restart: ƒ, redirect: ƒ}
      order: {capture: ƒ, authorize: ƒ, patch: ƒ, get: ƒ}
      payment: null
      subscription: {get: ƒ, activate: ƒ}
      restart: ƒ crossDomainFunctionWrapper()
      redirect: ƒ crossDomainFunctionWrapper()
                                 */

                //First create the uniqueOrderId and store it as invoice_id to the paypal order
                if (!_this.paypalOrderId || _this.paypalOrderId.length === 0) {
                  console.log('paypalOrderId missing');
                  return;
                }

                _this.payPalOnApprove(_this, _store, _uid, data, actions);
              } else {
                let info = 'Double event prevented payPal2 inhouse mp';
                console.log(info);
                ebus.$emit('throwError', getErrorDetails(info));
              }

            }
          }).render('#paypal-button-container');//mount paypal button
        } catch (ex) {
          let paypalScript = window.document.getElementById('paypalScript');
          let paypalScriptSrc = '';
          if (paypalScript) {
            paypalScriptSrc = '' + paypalScriptSrc.src;
          }
          this.notifyError('Internet Verbindungsfehler PayPal');
          let e = 'error: PayPal lazyCreatePaymentRequest inhouse mp: Internet Verbindungsfehler P ' +
              'paypalScriptSrc=' + paypalScriptSrc + ': ' + ex.message;
          console.log(e);
          ebus.$emit('throwError', getErrorDetails(e));
          // ebus.$emit('forceReload');
          return false;
        }
      }

      //Goodpay
      // this.initGoodpayCreditTx();

      return true;
    },

    initGoodpayWalletTx(walletToken, isApple, isGoogle) {
      try {
        console.log('goodpay initGoodpayWalletTx for ' + isApple ? 'apple' : 'google' + ' walletToken ' + walletToken);
        // if (!this.paymentRequestCreated) {
        this.safeUnload(20);
        let self = this;
        let _store = store;

        let goodpayWalletTxData = {
          amount: 0 + this.total,
          uniqueOrderId: '' + this.order.uniqueOrderId,
          retry: 0,
          returnIrl: '',
          token: walletToken,
          isGoogle: isGoogle,
          isApple: isApple,
        }

        let msg = {
          action: action$GoodpayFrontendApi,
          method: 'initTransaction',
          data: goodpayWalletTxData,
        };
        xhr.xhrSend(true, msg, (reply) => {
          if (reply.ok && reply.response && reply.response.ok) {
            console.log('goodpay initGoodpayWalletTx was ok: ' + JSON.stringify(reply));
            self.goodpayWalletTransaction = reply.response.obj;
            // {
            //   "ok": true,
            //     "response": {
            //     "ok": true,
            //       "obj": {
            //       "ResponseHeader": {
            //         "SpecVersion": "1.35",
            //           "RequestId": "iniTx_1HKQ0O-10022"
            //       },
            //       "Token": "q0f24ls75vg6w1vnkuapcrgop",
            //         "Expiration": "2023-11-08T13:16:52.054+01:00",
            //         "LiabilityShift": true,
            //         "RedirectRequired": true,
            //         "Redirect": {
            //         "RedirectUrl": "https://test.saferpay.com/vt2/Api/Dcc/270028/17759980/q0f24ls75vg6w1vnkuapcrgop",
            //           "PaymentMeansRequired": false
            //       }
            //     }
            //   }
            // }

            //Next step in flow is: https://docs.saferpay.com/home/integration-guide/licences-and-interfaces/transaction-interface#transaction-initialize-response
            self.goodpayWalletTxToken = reply.response.obj.Token;
            self.goodpayWalletExpireAt = (new Date(reply.response.obj.Expiration)).getTime();
            console.log('goodpay initGoodpayWalletTx goodpayWalletTxToken: ' + self.goodpayWalletTxToken);

            let authData = {
              txToken: self.goodpayWalletTxToken,
              uniqueOrderId: goodpayWalletTxData.uniqueOrderId,
              liabilityShift: reply.response.obj.LiabilityShift,
              txData: goodpayWalletTxData,
            };
            self.goodpayWalletAuthData = authData;
            console.log('goodpay goodpayWalletAuthData for isGoogle=' + isGoogle + ' has been set to ' + authData);

            if (reply.response.obj.RedirectRequired) {
              let redirectUrl = reply.response.obj.Redirect.RedirectUrl;
              console.log('goodpay initGoodpayWalletTx redirectUrl: ' + redirectUrl
              );

              self.goodpayWalletTransaction.redirectUrl = redirectUrl;
              setGlobalKeyValue('ccRedirectUrl', redirectUrl);
              store.commit('secondSelectedDialog', 'IframeOverlay');
              store.commit('showDialogContainer', true);
              ebus.$emit('triggerIframeOverlay', redirectUrl);
            } else {
              console.log('goodpay directly invoke goodpayTxAuthroize');
              self.goodpayTxAuthroize(self, _store, authData, true);
            }

          } else {
            console.log('error: goodpay initGoodpayWalletTx was notOk');
            let e = 'Code TWA'; //takeaway wallet transaction A

            if (!isEmptyObject(reply)) {
              let detailedMessage = JSON.stringify(reply);
              e += ' - ' + detailedMessage;
            }

            self.notifyError(e);
            self.stopLoading();
          }
        }, (err) => {
          console.log('goodpay initGoodpayWalletTx unexpectederror: ' + err);
          let e = 'Code TWU';  //takeaway wallet transaction unexpected
          self.notifyError(e);
          self.stopLoading();
          ebus.$emit('throwError', getErrorDetails(err, 'CheckoutInhouseMitOnlinePaymentTip', ' error=' + e));
        }, 20 * 1000);

      } catch (ex) {
        let e = 'Internet Verbindungsfehler Code TWTX'; //takeaway wallet tx
        this.notifyError(e);
        ebus.$emit('throwError', getErrorDetails(ex, 'CheckoutInhouseMitOnlinePaymentTip', e));
        // ebus.$emit('forceReload');
      }
    },

    goodpayTxAuthroize(self, _store, authData, isWallet) {
      try {
        console.log('goodpay goodpayTxAuthroize isWallet=' + isWallet + ' authData: ' + JSON.stringify(authData));
        self.safeUnload(20);

        let msg = {
          action: action$GoodpayFrontendApi,
          method: 'transactionAuthorize',
          data: authData,
        };
        xhr.xhrSend(true, msg, (reply) => {
          if (reply.ok && reply.response && reply.response.ok) {
            console.log('goodpay goodpayTxAuthroize was ok: ', reply);

            let obj = reply.response.obj;

            let liability = obj.Liability;
            // "Liability": {
            //   "LiabilityShift": true,
            //     "LiableEntity": "THREEDS",
            //     "ThreeDs": {
            //     "Authenticated": true,
            //       "Xid": "ARkvCgk5Y1t/BDFFXkUPGX9DUgs="
            //   }
            // }

            let paymentAuth = null;
            if (isWallet) {
              paymentAuth = {
                goodpayWalletTxToken: authData.txToken,
                transactionId: obj.Transaction.Id,
                transaction: obj.Transaction,
                authData: authData,
                liability: liability,
              };
            } else {
              paymentAuth = {
                goodpayTransactionToken: self.goodpayTxToken,
                aliasId: self.goodpayTxIsForAliasId,
                transactionId: obj.Transaction.Id,
                transaction: obj.Transaction,
                authData: authData,
                liability: liability,
              };
            }

            self.markOrderAsAuthorized(false, paymentAuth, self, _store);
          } else {
            console.log('goodpay autherror: ', reply);
            self.stopLoading();
//{
//             "ok": false,
//               "response": {
//               "statusCode": 402,
//                 "responseBody": {
//                 "ResponseHeader": {
//                   "SpecVersion": "1.35",
//                     "RequestId": "authorize_1HHMOO-10017"
//                 },
//                 "Behavior": "DO_NOT_RETRY",
//                   "ErrorName": "3DS_AUTHENTICATION_FAILED",
//                   "ErrorMessage": "3D-Secure authentication failed",
//                   "TransactionId": "84Qz5Yb4bbvdtAfnYj6vb191pjWb",
//                   "OrderId": "1HHMOO-10017"
//               }
//             }
//           }
            let e = 'Die Authorisierung ist fehlgeschlagen: ' + JSON.stringify(reply);
            this.notifyError(e);
            ebus.$emit('throwError', getErrorDetails(e + ':  ' + JSON.stringify(reply)))

//             this.notifyError('Die Authorisierung ist fehlgeschlagen', reply.response.responseBody.ErrorMessage);
          }
        });

      } catch (ex) {
        let e = 'Code TXAU: '; // inhouse tansaction authorize unexpected
        this.notifyError(e);
        this.stopLoading();
        ebus.$emit('throwError', getErrorDetails(ex, 'CheckoutInhouseMitOnlinePaymentTip', e));
        // ebus.$emit('forceReload');
      }
    },

    initGoodpayCreditTx() {
      try {
        console.log('goodpay initGoodpayCreditTx');
        this.safeUnload(20);

        let self = this;
        let _store = store;

        let aliasId = this.selectedAliasId;
        if (!aliasId) {
          console.log('goodpay initGoodpayCreditTx cancelled because aliasId is missing');
          this.notifyError('Fehler! Die Kreditkartenverarbeitung kann nicht gestartet werden');
          return;
        }

        // if (!this.paymentRequestCreated) {
        let goodpayTxData = {
          amount: 0 + this.total,
          uniqueOrderId: '' + this.order.uniqueOrderId,
          retry: 0,
          aliasId: aliasId,
        }

        let msg = {
          action: action$GoodpayFrontendApi,
          method: 'initTransaction',
          data: goodpayTxData,
        };
        xhr.xhrSend(true, msg, (reply) => {
          if (reply.ok && reply.response && reply.response.ok) {
            console.log('goodpay initTransaction was ok: ', reply);
            self.goodpayTxIsForAliasId = aliasId;
            self.goodpayCreditTransaction = reply.response.obj;
            //{"ok":true,"response":{"ok":true,
            // "obj":{
            // "ResponseHeader":{"SpecVersion":"1.35","RequestId":"1FKXC8-10025"},
            // "Token":"gij2axvifo0dr3ou5y5rxnqau",
            // "Expiration":"2023-09-30T19:45:37.383+02:00",
            // "RedirectRequired":true,"Redirect":
            // {"RedirectUrl":"https://test.saferpay.com/vt2/Api/Post/270028/17759980/gij2axvifo0dr3ou5y5rxnqau",
            // "PaymentMeansRequired":true}}}}
            self.goodpayTxToken = reply.response.obj.Token;
            self.goodpayExpireAt = (new Date(reply.response.obj.Expiration)).getTime();
            console.log('goodpay initTransaction goodpayTxToken: ' + self.goodpayTxToken);

            let authData = {
              txToken: self.goodpayTxToken,
              uniqueOrderId: goodpayTxData.uniqueOrderId,
              liabilityShift: reply.response.obj.LiabilityShift,
              txData: goodpayTxData,
            };
            self.goodpayCreditAuthData = authData;

            if (reply.response.obj.RedirectRequired) {
              let redirectUrl = reply.response.obj.Redirect.RedirectUrl;
              console.log('goodpay initGoodpayCreditTx'
                  + ' redirectUrl: ' + redirectUrl
              );

              self.goodpayCreditTransaction.redirectUrl = redirectUrl;
              setGlobalKeyValue('ccRedirectUrl', redirectUrl);
              store.commit('secondSelectedDialog', 'IframeOverlay');
              store.commit('showDialogContainer', true);
              ebus.$emit('triggerIframeOverlay', redirectUrl);
            } else {
              self.goodpayTxAuthroize(self, _store, authData, false);
            }

            //token is valid for 20 minutes

          } else {
            console.log('error: goodpay initTransaction was notOk');
            this.notifyError('Fehler bei der Kartenverarbeitung');
            self.stopLoading();
          }
        }, (err) => {
          console.log('goodpay initTransaction unexpectederror: ' + err);
          this.notifyError('Unerwarteter Fehler bei der Kartenverarbeitung');
          self.stopLoading();
        }, 20 * 1000);


      } catch (ex) {
        this.notifyError('Internet Verbindungsfehler TC'); //Takeway Credit
        let e = 'goodpay initGoodpayCreditTx error inhouse mp: ' + ex.message;
        console.log(e);
        ebus.$emit('throwError', getErrorDetails(e));
        // ebus.$emit('forceReload');
      }
    },

    // clickDelivery() {
    //     this.usecase = 'delivery';
    //     this.updateTotal();
    //     util.delayScroll('checkData');
    // },

    // clickInhouse() {
    //     this.usecase = 'inhouse';
    //     this.updateTotal();
    //     util.delayScroll('checkData');
    // },

    checkEnter() {
      try {
        if (
            // (!this.$ls.get('asGuest',true) && store.getters.loggedIn === false) ||
            store.getters.cartItems.length === 0
            || !store.getters.orderingEnabled
            || (store.getters.table < 1 && !store.state.orderArea)
        ) {
          ebus.$emit('gotoStart');
          return false;
        }
        return true;
      } catch (e) {
        console.log('Error in checkEnter...');
        ebus.$emit('gotoStart');
        return false;
      }
    },

    // updateDeliveryAddressInAccount() {
    //     let da = util.cloneMe(this.deliveryAddress);
    //     // da.company.trim();
    //     da.street.trim();
    //     da.plz.trim();
    //     da.city.trim();
    //     da.etage.trim();
    //
    //     if (da && da.plz && da.street && da.street.length > 0) {
    //         let upsertMsg = {
    //             action: qconst.action$UpsertAppUser,
    //             fuid: firebaseUtil.getUser().uid,
    //             deliveryAddress: da,
    //         };
    //         xhr.xhrSend(true, upsertMsg, (response) => {
    //             console.log('deliveryAddress updated in account')
    //         }, (err) => {
    //             console.log('error updating deliveryAddress in account: ' + e.message);
    //         });
    //         this.$ls.set('deliveryAddress', JSON.stringify(da));
    //     }
    // },

    preselectFields() {
      try {
        let fd = this.$ls.get('inhouseformData', {});
        this.hasFd = !util.isEmptyObject(fd);
        if (this.hasFd) {
          if (fd.name) {
            this.name = fd.name;
          }
          if (fd.email) {
            this.email = util.sanitizeEmail(fd.email);
          }
          if (fd.phone) {
            this.phone = util.sanitizePhone(fd.phone);
          }
          if (fd.invoiceAddress && fd.invoiceAddress.street.length > 0) {
            this.invoiceAddress = fd.invoiceAddress;
          }
          // if (fd.note) {
          //   this.note = fd.note;
          // }
        } else {
          // this.invoiceAddress.plz = store.state.defaultPlz; //default PLZ
          // this.invoiceAddress.city = store.state.defaultCity; //default City
        }
        let fbUser = firebaseUtil.getUser();
        if (fbUser) {
          if (fbUser.displayName) {
            this.name = fbUser.displayName;
          }
          if (fbUser.email) {
            this.email = fbUser.email;
          }
          if (fbUser.phoneNumber) {
            this.phone = fbUser.phoneNumber;
          }
        }
        this.resetValidation();
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in load form: ' + e.message));
      }
    },

    init(eventSource) {
      try {
        // alert('init eventSource '+eventSource);
        // this.currentStep = 1;
        this.consent = false;

        this.showBar = !!store.state.appContext.bar;
        this.showGoodpayGoogleWallet = enableGoodpay && !isIos() && window.PaymentRequest;//!!store.state.appContext.credit;
        this.showGoodpayAppleWallet = enableGoodpay && (isIos() || !PROD_ENV);
        // this.showWallet = !!store.state.appContext.credit;
        this.showPaypal = enablePaypal;

        this.psp = ''; // default

        // this.initTimesArray();

        //preselect time
        // this.preselectTime();


        // this.initTimesArray();
        //
        // //preselect time
        // let st = store.getters.selectedTime;
        // for (let t of this.times) {
        //     if (t.value === st.value) {
        //         this.time = t;
        //         break;
        //     }
        // }

        //init stores
        // this.stores = util.cloneMe(store.getters.stores);

        // //preslect autoModel the store from the local store
        // let lsSelectedStore = this.$ls.get('selectedStore');
        // if (lsSelectedStore) {
        //     let lss = JSON.parse(lsSelectedStore);
        //     if (lss.plz && lss.strasse) {
        //         store.getters.selectedStore = util.cloneMe(lss);
        //         this.autoModel = {
        //             displayName: lss.strasse + ', ' + lss.plz + ' ' + lss.ort,
        //             obj: lss
        //         };
        //     }
        // }

        //preselect psp
        // if (this.showBar) {
        //     this.psp = 'bar';
        // } else if (this.showGoodpayWallet) {
        //     this.psp = 'credit';
        // } else if (this.showPaypal) {
        //     this.psp = 'paypal';
        // }

        //fill name, email, phone, invoiceAddress and deliveryAddress as possible
        // if (!this.asGuest) {
        //     let user = firebaseUtil.getUser();
        //     if (user) {
        //         if (user.displayName && user.displayName.indexOf(' ') > 0) {
        //             this.name = user.displayName;
        //         }
        //         this.email = user.email;
        //         this.phone = user.phoneNumber;
        //         // //init vorname und nachname
        //         // this.vorname = user.displayName.substring(0, user.displayName.indexOf(' '));
        //         // this.nachname = user.displayName.substring(user.displayName.indexOf(' '), user.displayName.length);
        //     }
        // }

        this.preselectFields();

        // if(this.invoiceAddress.street.length === 0){
        //     //preselect company
        //     let _company = this.$ls.get('company');
        //     if (_company) {
        //         this.invoiceAddress.company = _company;
        //     }
        //
        //     let _invoiceAddress = this.$ls.get('invoiceAddress');
        //     if (_invoiceAddress) {
        //         let ia = JSON.parse(_invoiceAddress);
        //         if (ia.company) {
        //             this.invoiceAddress.company = ia.company;
        //         }
        //         if (ia.street) {
        //             this.invoiceAddress.street = ia.street
        //         }
        //         if (ia.plz) {
        //             this.invoiceAddress.plz = ia.plz
        //         }
        //         if (ia.city) {
        //             this.invoiceAddress.city = ia.city
        //         }
        //         // if (ia.etage) {
        //         //     this.invoiceAddress.etage = ia.etage
        //         // }
        //     }
        // }
        //
        // if(this.deliveryAddress.street.length === 0){
        //     let _deliveryAddress = this.$ls.get('deliveryAddress');
        //     if (_deliveryAddress) {
        //         let da = JSON.parse(_deliveryAddress);
        //         if (da.company) {
        //             this.deliveryAddress.company = da.company;
        //         }
        //         if (da.street) {
        //             this.deliveryAddress.street = da.street
        //         }
        //         if (da.plz) {
        //             this.deliveryAddress.plz = da.plz
        //         }
        //         if (da.city) {
        //             this.deliveryAddress.city = da.city
        //         }
        //         if (da.etage) {
        //             this.deliveryAddress.etage = da.etage
        //         }
        //     }
        // }


        // this.usecase = store.state.goforTakeaway ? 'inhouse' : 'delivery';

        //Only for delivery usecase
        // let _deliveryAddress = this.$ls.get('deliveryAddress');
        // if (_deliveryAddress) {
        //     let da = JSON.parse(_deliveryAddress);
        //     if (da.company) {
        //         this.deliveryAddress.company = da.company;
        //     }
        //     if (da.street) {
        //         this.deliveryAddress.street = da.street;
        //     }
        //     if (da.plz) {
        //         this.deliveryAddress.plz = da.plz;
        //     }
        //     if (da.city) {
        //         this.deliveryAddress.city = da.city;
        //     }
        //     if (da.etage) {
        //         this.deliveryAddress.etage = da.etage;
        //     }
        // }


        this.updateTotal();
        // this.updateMinOrderAmount();
        // this.updateDeliveryFee();


        // //init times array
        // let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        // let allMinutes = ['00', '15', '30', '45'];
        //
        // // let isFirstTime = true;
        //
        // //day1
        // if (store.state.day1.opened) {
        //     this.internalDaySelected = '1';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     let rNow = util.getCurrentRemoteTime();
        //     let currentHour = rNow.getHours();
        //     let currentMinutes = rNow.getMinutes();
        //     let zieltermin = util.calculateZielterminOfToday(store.getters.appconfig.takeAway.delayInMinutes);
        //
        //     console.log('???? zieltermin hours = ' + zieltermin.getHours());
        //
        //     for (let hour of relevantHours) {
        //
        //         //ignore hours before zieltermin
        //         if (hour < zieltermin.getHours()) {
        //             continue;
        //         }
        //
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //
        //         for (let minute of allMinutes) {
        //             if (hour === currentHour) {
        //
        //                 let _minute = parseInt(minute, 10);
        //
        //                 //ignore minutes before now
        //                 if (_minute <= currentMinutes) {
        //                     continue;
        //                 }
        //
        //                 //ignore minutes before zieltermin
        //                 if (_minute < zieltermin.getMinutes()) {
        //                     continue;
        //                 }
        //             }
        //             this.times1.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }
        //
        // //day2
        // if (store.state.day2.opened) {
        //     this.internalDaySelected = '2';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     for (let hour of relevantHours) {
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //         for (let minute of allMinutes) {
        //             this.times2.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }

        //the payment intent is already ready to go
      } catch (e) {
        console.log('Error: ' + e.message);
        ebus.$emit('info', 'Fehler bei der Initialisierung');
      }
    },//eof init

    preselectTime() {
      //     let st = store.getters.selectedTime;
      //     if (this.selectedAbholDatum === 'Heute') {
      //         for (let t of this.timesToday) {
      //             if (t.value === st.value) {
      //                 this.time = t;
      //                 break;
      //             }
      //         }
      //     } else {
      //         for (let t of this.timesTomorrow) {
      //             if (t.value === st.value) {
      //                 this.time = t;
      //                 break;
      //             }
      //         }
      //     }
    },

    // initTimesArray() {
    //     console.log('initTimesArray...');
    //     let appconfig = util.cloneMe(store.getters.appconfig);
    //     if (!appconfig.inhouse.openingHours['1']) {
    //         //XHR has not finished loading the appconfig yet
    //         return;
    //     }
    //     //init times array
    //
    //     this.timesToday.splice(0, this.timesToday.length);
    //     this.timesTomorrow.splice(0, this.timesTomorrow.length);
    //
    //     //takwaways either on today or tomorrow so we need to filter the hours
    //     let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    //     // let allMinutes = ['00', '15', '30', '45'];
    //     // let moreMinutes = ['00', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
    //
    //     //calculate delayInMinutes
    //     let delayInMinutes = util.calcDelayInMinutes(appconfig.inhouse.delayInMinutes, util.cloneMe(store.getters.cartItems));
    //
    //     //Init Heute timesToday
    //     // this.internalDaySelected = '1';
    //     let today = util.getDayOfWeek(new Date());
    //     let ohsToday = appconfig.inhouse.openingHours['' + today];
    //     // console.log('openedToday = '+ohsToday.opened);
    //     if (ohsToday.opened) {
    //         let relevantHours = allHours.filter((h) => {
    //             return this.allowedHours(h, ohsToday)
    //         });
    //
    //         if (relevantHours) {
    //             // let nextDay = util.getNextDay();
    //             let rNow = new Date();
    //             let currentHour = rNow.getHours();
    //             let currentMinutes = rNow.getMinutes();
    //             let earliestAbholung = util.calculateZielterminOfToday(delayInMinutes);
    //             // console.log('???? earliestAbholung utc = ' + earliestAbholung.getTime());
    //
    //             for (let hour of relevantHours) {
    //
    //                 //ignore hours before zieltermin
    //                 if (hour < earliestAbholung.getHours()) {
    //                     continue;
    //                 }
    //
    //                 let h = '' + hour;
    //                 if (hour < 10) {
    //                     h = '0' + h;
    //                 }
    //
    //                 this.generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohsToday, this.timesToday, true);
    //             }//eof of init today
    //         }
    //
    //     }
    //     if (this.timesToday.length > 0) {
    //         this.abholDatumArray[0].value = 'Heute';
    //     } else {
    //         this.abholDatumArray[0].value = 'Heute geschlossen';
    //     }
    //
    //
    //     //init Morgen timesTomorrow
    //     // this.internalDaySelected = '1';
    //     let tomorrow = util.getNextDay();
    //     let ohsTomorrow = appconfig.inhouse.openingHours['' + tomorrow];
    //     if (ohsTomorrow.opened) {
    //         let relevantHours2 = allHours.filter((h) => {
    //             return this.allowedHours(h, ohsTomorrow)
    //         });
    //         // let nextDay = util.getNextDay();
    //         // let rNow = new Date();
    //         // let currentHour = rNow.getHours();
    //         // let currentMinutes = rNow.getMinutes();
    //         // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
    //         if (relevantHours2) {
    //             for (let hour of relevantHours2) {
    //
    //                 //ignore hours before zieltermin
    //                 // if (hour < zieltermin.getHours()) {
    //                 //     continue;
    //                 // }
    //
    //                 let h = '' + hour;
    //                 if (hour < 10) {
    //                     h = '0' + h;
    //                 }
    //
    //                 this.generateMinutes(delayInMinutes, h, hour, null, null, ohsTomorrow, this.timesTomorrow, false);
    //
    //
    //             }//eof of init tomorrow
    //         }
    //
    //
    //     }
    //     if (this.timesTomorrow.length > 0) {
    //         this.abholDatumArray[1].value = 'Morgen';
    //     } else {
    //         this.abholDatumArray[1].value = 'Morgen geschlossen';
    //     }
    //
    //
    //     // this.preselectDay1();
    // },

    // generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohs, timesArray, forToday) {
    //     try {
    //         let lessMinutes = ['00', '15', '30', '45'];
    //         let allMinutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
    //         for (let minute of allMinutes) {
    //             let _minute = parseInt(minute, 10);
    //
    //             let utcValue;
    //             if (forToday) {
    //                 utcValue = new Date();
    //             } else {
    //                 utcValue = util.addDays(util.getCurrentRemoteTime(), 1);
    //             }
    //             // console.log('checkout utc = ' + nd.getTime());
    //             // console.log('checkout utc date = ' + nd);
    //             // console.log('checkout utc locale = ' + nd.toLocaleString());
    //             utcValue.setHours(hour);
    //             utcValue.setMinutes(_minute);
    //             let diff2Now = utcValue.getTime() - Date.now();
    //             let isWithin60Minutes = diff2Now < (1000 * 60 * 60);
    //             if (isWithin60Minutes || forToday) {
    //                 //ignore times if delayInMinutes from now is too small
    //                 if (diff2Now < (delayInMinutes * 60 * 1000)) {
    //                     continue;
    //                 }
    //             }
    //
    //             if (forToday) {
    //                 if (hour === currentHour) {
    //                     //ignore minutes before now
    //                     if (_minute <= currentMinutes) {
    //                         continue;
    //                     }
    //                 }
    //             }
    //
    //             if (!isWithin60Minutes) {
    //                 if (!lessMinutes.includes(minute)) {
    //                     continue; //less minutes for everything later than 60 minutes
    //                 }
    //             }
    //
    //             if (hour === ohs.a.fromHour) {
    //                 if (!(ohs.a.fromMinute <= _minute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === ohs.a.tillHour) {
    //                 if (!(_minute <= ohs.a.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === ohs.b.fromHour) {
    //                 if (!(ohs.b.fromMinute <= _minute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === ohs.b.tillHour) {
    //                 if (!(_minute <= ohs.b.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //
    //             timesArray.push({
    //                 value: h + ':' + minute,
    //                 display: 'ca. ' + h + ':' + minute + ' Uhr',
    //                 utc: utcValue.getTime()
    //             });
    //         }
    //     } catch (e) {
    //         ebus.$emit('throwError', getErrorDetails('Exception in generateMinutes: ' + e.message);
    //     }
    // },

    // initTimesArray() {
    //     //init times array
    //     //takwaways is always on the next day so we don't neet to filter the times
    //     let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    //     let allMinutes = ['00', '30'];
    //
    //     // let isFirstTime = true;
    //
    //     // this.internalDaySelected = '1';
    //     let relevantHours = allHours.filter(this.allowedHours);
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //     // let currentMinutes = rNow.getMinutes();
    //     // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
    //
    //     // console.log('???? zieltermin hours = ' + zieltermin.getHours());
    //
    //     for (let hour of relevantHours) {
    //
    //         //ignore hours before zieltermin
    //         // if (hour < zieltermin.getHours()) {
    //         //     continue;
    //         // }
    //
    //         let h = '' + hour;
    //         if (hour < 10) {
    //             h = '0' + h;
    //         }
    //
    //         for (let minute of allMinutes) {
    //             let minNum = 0;
    //             if (minute !== '00') {
    //                 minNum = 30;
    //             }
    //
    //             if (hour === relevantDay.a.fromHour) {
    //                 if (!(relevantDay.a.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.a.tillHour) {
    //                 if (!(minNum <= relevantDay.a.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.fromHour) {
    //                 if (!(relevantDay.b.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.tillHour) {
    //                 if (!(minNum <= relevantDay.b.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //
    //             // if (hour === currentHour) {
    //             //
    //             //     let _minute = parseInt(minute, 10);
    //             //
    //             //     //ignore minutes before now
    //             //     if (_minute <= currentMinutes) {
    //             //         continue;
    //             //     }
    //             //
    //             //     //ignore minutes before zieltermin
    //             //     if (_minute < zieltermin.getMinutes()) {
    //             //         continue;
    //             //     }
    //             // }
    //
    //             let nd = util.addDays(util.getCurrentRemoteTime(), 1);
    //             // console.log('checkout utc = ' + nd.getTime());
    //             // console.log('checkout utc date = ' + nd);
    //             // console.log('checkout utc locale = ' + nd.toLocaleString());
    //             nd.setHours(hour);
    //             nd.setMinutes(minNum);
    //
    //
    //             this.times.push({
    //                 value: h + ':' + minute,
    //                 display: h + ':' + minute + ' Uhr',
    //                 utc: nd.getTime()
    //             });
    //             // if (isFirstTime) {
    //             //     this.time = h + ':' + minute;
    //             //     isFirstTime = false;
    //             // }
    //         }
    //     }
    //     // this.preselectDay1();
    // },

    // preselectDay1() {
    //     //preselect first option
    //     if (this.times1.length > 0) {
    //         this.time = this.times1[0].value;
    //     }
    // },

    // preselectDay2() {
    //     //preselect first option
    //     if (this.times2.length > 0) {
    //         this.time = this.times2[0].value;
    //     }
    // },

    // allowedHours(h, dayOh) {
    //     // let rNow = Date.now();
    //     // let currentHour = rNow.getHours();
    //
    //     // if (isToday) {
    //     //     //ignore hours before now
    //     //     if (h < currentHour) {
    //     //         return false;
    //     //     }
    //     // }
    //     //check period a
    //     let matchesA = dayOh.a.fromHour <= h && h <= dayOh.a.tillHour;
    //     if (matchesA) {
    //         return true;
    //     }
    //     if (dayOh.b.fromHour !== dayOh.b.tillHour) {
    //         return dayOh.b.fromHour <= h && h <= dayOh.b.tillHour;
    //     }
    //     return false;
    // },

    selectMethod(pMethod) {
      this.selectedAliasId = pMethod.aliasId;
      console.log('??? selected aliasId=' + this.selectedAliasId);
      // if (pMethod.aliasId !== this.goodpayTxIsForAliasId) {
      //   this.initGoodpayCreditTx();
      // }
    },

    gotoSummary() {
      this.$router.push({name: 'Korb'});
    },

    gotoAccount() {
      this.$router.push({name: 'Account'});
    },

    changeFiliale() {
      ebus.$emit('triggerFilialeDialog')
    },

    gotoPms(onlyShow) {
      // if (!onlyShow) {
      this.setFromCheckout();
      setGlobalKeyValue('pmForCheckout', true);
      // }
      store.commit('secondSelectedDialog', '');
      store.commit('selectedDialog', 'PaymentMethods');
      store.commit('showDialogContainer', true);
      ebus.$emit('addCardForCheckout');
      // this.$router.push({
      //   name: 'Zahlungsmittel'
      // });
    },


    //Überprüfe deine Daten
    finishStep1() {

      this.$nextTick(() => {
        if (!this.validate() || !this.step1Ok) {
          this.initialTry = true;
          return;
        }

        checkoutUtil.reset();
        this.email = util.removeSpaces(this.email);

        this.saveForm();

        //double check
        // let err = this.step1Ok();
        // if () {
        //     return;
        // }

        // if (!store.state.user.name || store.state.user.name.length < 3) {
        //     ebus.$emit('showInfo', {title: 'Gib deinen Namen ein, um fortzufahren'});
        //     return;
        // }

        if (store.getters.cartSum === 0) {
          this.$router.push({name: 'Korb'});
          return;
        }

        // //Prüfe den Mindestbestellwert
        // if (store.getters.cartSum < store.getters.appconfig.inhouse.minOrderAmount) {
        //     // if (store.getters.cartSum < store.getters.selectedStore.minOrderAmount) {
        //     // if (store.getters.cartSum < this.minOrderAmount) {
        //     //     if (this.usecase === 'delivery') {
        //     this.$router.push({name: 'Korb'});
        //     ebus.$emit('showInfo', {
        //         title: 'Bitte beachte den Mindestbestellwert von '
        //             + util.getLocalPrice(store.getters.appconfig.inhouse.minOrderAmount)
        //     });
        //     return;
        //     // }
        // }

        //Prüfe Verfügbarkeit aller Waren
        // let itemsNotAvailable = [];
        // for (let itm of store.getters.cartItems) {
        //     if (itm.couponCode) {
        //         continue;
        //     }
        //     if (!plausi.itemAvailableTomorrow(itm)) {
        //         itemsNotAvailable.push(itm);
        //     }
        // }
        // if (itemsNotAvailable.length > 0) {
        //     let names = itemsNotAvailable.map(itm => itm.nameToDisplay);
        //     // let filialeName = store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
        //     ebus.$emit('showInfo', {
        //         title: 'Folgende Waren sind morgen nicht verfügbar: ' + this.$options.filters.stringList(names),
        //         text: 'Bitte entfernen Sie nicht verfügbare Waren aus dem Korb.'
        //     });
        //     this.$router.push({name: 'Korb'});
        //     return;
        // }

        this.updateTotal();

        util.closeSoftKeyBoard();

        this.currentStep = 2;
      });
    },

    finishStep2() {
      this.updateTotal();

      this.$nextTick(() => {
        if (!this.step2Ok) {
          this.initialTry = true;
          return;
        }

        checkoutUtil.reset();

        //first step before starting any payment is to store the order
        this._saveOrder(0);
      });
    },

    safeUnload(seconds, self) {
      try {
        if (!self) {
          self = this;
        }
        if (isNaN(seconds)) {
          seconds = 6;
        }
        let now = Date.now();
        let millis = seconds * 1000;
        let targetTime = now + millis;
        self.unloadTargetTime = targetTime
        store.commit('showLoading', true);
        setTimeout(() => {
          let diff = Date.now() - self.unloadTargetTime;
          if (diff > -600 && diff < 600) {
            store.commit('showLoading', false);
          }
        }, millis);
      } catch (e) {
        console.log('error in safeUnload: ' + e.message);
      }
    },

    stopLoading(self) {
      if (!self) {
        self = this;
      }
      self.loading = false;
      store.commit('showLoading', false);
      this.unloadTargetTime = 0;
    },

    reloadCaptcha() {
      // // store.commit('showLoading', true);
      // this.generateCaptcha((responseOrFalse) => {
      //     if (responseOrFalse) {
      //         this.renderCaptcha(responseOrFalse);
      //     }
      //     // store.commit('showLoading', false);
      // });
    },

    async renderCaptcha(arrayBuffer) {
      // try {
      //     // Obtain a blob: URL for the image data.
      //     let arrayBufferView = new Uint8Array(arrayBuffer);
      //     let blob = new Blob([arrayBufferView], {type: "image/jpeg"});
      //     let urlCreator = window.URL || window.webkitURL;
      //     let imageUrl = urlCreator.createObjectURL(blob);
      //     let img = document.getElementById("captchaUmage");
      //     this.$nextTick(() => {
      //         img.src = imageUrl;
      //     });
      //
      //     // let img = new Image();
      //     // // let response = base64Buffer;
      //     // // let binary = '';
      //     // // for (let i = 0; i < response.length; i++) {
      //     // //     binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
      //     // // }
      //     //
      //     // // img.src = 'data:image/jpeg;base64,' + btoa(binary);
      //     // img.src = 'data:image/jpeg;base64,' + base64Buffer;
      //     // let canvas = document.getElementById('captchaUmage');
      //     //
      //     // let context = canvas.getContext('2d');
      //     // this.$nextTick(() => {
      //     //     context.drawImage(img, 0, 0);
      //     // });
      // } catch (e) {
      //     ebus.$emit('throwError', getErrorDetails('error in drawCaptcha: ' + e.message);
      //     console.log('error in drawCaptcha: ' + e.message);
      // }
    },

    generateCaptcha(cb) {
      // xhr.xhrGetImage('xhr/captcha/generate',
      //     // {
      //     //     'Accept': '*/*'
      //     // },
      //     (reponseData) => {
      //         if (cb) {
      //             cb(reponseData);
      //         }
      //     },
      //     (err) => {
      //         if (cb) {
      //             cb(false);
      //         }
      //     }
      // );
    },

    saveForm() {
      try {
        let _fd = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          // note: this.note,
        };
        let fd = util.cloneMe(_fd);
        let ia = this.invoiceAddress;
        if (ia && ia.street && ia.street.length > 0) {
          fd.invoiceAddress = util.cloneMe(ia);
        }
        let da = this.deliveryAddress;
        if (da && da.street && da.street.length > 0) {
          fd.deliveryAddress = util.cloneMe(da);
        }
        util.sanitizeProps(fd);
        util.removeEmptyProps(fd);
        let san = util.sanitizePhone(fd.phone);
        if (san) {
          fd.phone = san;
        }
        let sanEmail = util.sanitizeEmail(fd.email);
        if (sanEmail) {
          fd.email = sanEmail;
        }
        if (fd.name || fd.phone) {
          this.$ls.set('inhouseformData', fd);
        }

        let user = {
          name: fd.name,
          email: fd.email,
          phone: fd.phone,
        };
        util.removeEmptyProps(user);
        store.commit('user', user);

      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in saveForm: ' + e.message));
      }
    },

    //Abholzeit
    // finishStep3() {
    //
    //     console.log('timeSelected: ' + this.time);
    //
    //     // this.displayPickupDate = util.displayPickupDate(pickupDate);
    //     // this.displayPickupDate = util.alternativeDisplayPickupDate(this.daySelected, this.time);
    //
    //     this.currentStep = 4;
    //
    //     if (this.psp !== 'bar') {
    //         setTimeout(() => {
    //             util.delayScroll('paymentRadios');
    //         }, 900);
    //     }
    // },

    // finishStep3() {
    //     if (this.consentA && this.consentB) {
    //         this.currentStep = 4;
    //     }
    // },

    checkMobilnummer() {
      if (!isMobileOk(this.phone)) {
        // let restName = store.state.restaurantData.restaurantName;
        if (this.initialTry) {
          ebus.$emit('showInfo', {
            title: 'Mobilnummer notwendig',
            text: 'Durch Angabe deiner Mobilnummer können wir nach deiner Bestellung ' +
                +'Kontakt zu dir aufnehmen'
          });
        }
        return false;
      }
      return true;
    },

    // allowedHours(h) {
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let relevantDay = store.state['day' + this.internalDaySelected];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //
    //     // if (this.internalDaySelected === '1') {
    //     // //ignore hours before now
    //     // if (h < currentHour) {
    //     //     return false;
    //     // }
    //     // }
    //
    //     //check period a
    //     let matchesA = relevantDay.a.fromHour <= h && h <= relevantDay.a.tillHour;
    //     if (matchesA) {
    //         return true;
    //     }
    //
    //     //check period b
    //     if (relevantDay.b.fromHour !== relevantDay.b.tillHour) {
    //         return relevantDay.b.fromHour <= h && h <= relevantDay.b.tillHour;
    //     }
    //     return false;
    // },

    // allowedMinutes(m) {
    //     if (m % 30 === 0) {
    //         return true;
    //     }
    //
    //     return false;
    // },

    // creditCollectPaymentMethod() {
    //     goodpayUtil.createCardElement();
    //     goodpayUtil.cardElement.mount('#card-element');
    //
    //     setTimeout(() => {
    //         this.initCreditSubmitButton();
    //     }, 600);//the mount takes a view milliseconds
    // },

    // initCreditSubmitButton() {
    //     const cardholderName = document.getElementById('cardholder-name');
    //     const cardButton = document.getElementById('card-button');
    //
    //     //always provide the customer’s name, email, billing address,
    //     // and shipping address (if available) to the credit.handleCardPayment call.
    //     cardButton.addEventListener('click', async (ev) => {
    //         //Note that credit.handleCardPayment may take several seconds to complete. During that time,
    //         // you should disable your form from being resubmitted and show a waiting indicator like a spinner.
    //         let _billing_details = {
    //             name: store.state.user.name,
    //             email: store.state.user.email
    //         };
    //         if (store.state.user.mobile) {
    //             _billing_details.mobile = store.state.user.mobile;
    //         }
    //
    //         const {paymentIntent, error} = await goodpayUtil.credit.handleCardPayment(
    //             this.clientSecret, goodpayUtil.cardElement, {
    //                 payment_method_data: {
    //                     billing_details: _billing_details
    //                 },
    //                 save_payment_method: true,
    //                 receipt_email: store.state.user.email
    //             }
    //         );
    //
    //         if (error) {
    //             // Display error.message in your UI.
    //             console.log('Payment error: ' + JSON.stringify(error));
    //         } else {
    //             // The payment has succeeded. Display a success message.
    //             console.log('Payment succeeded');
    //         }
    //     });
    // },

    doOrder() {
      if (!this.psp || this.psp === 'none') {
        return;
      }
      if (this.wait) {
        return
      }
      this.wait = true;
      setTimeout(() => this.wait = false, 2000);

      removeGlobalKey('chooseCustomercard');

      this.showSubmitButton = false;

      if (this.psp === 'credit') {
        store.commit('showLoading', true);
        //enable when using credit
        this.createCreditPaymentIntent();
      } else if (this.psp === 'paypal') {
        // store.commit('showLoading', true);
        // this.createGoodpayPaymentIntent();
        //PayPal has its own Button
      } else if (this.psp === 'customerCard') {
        // this.submitOrderWithCustomerCard(this, store);
        // store.commit('showLoading', true);
        // this.createCreditPaymentIntent();
        //PayPal has its own Button
      } else
          // if (this.checkMobilnummer())
      {
        //Barzahlung
        this.saveOrder(false);
      }
    },

    createCreditPaymentIntent() {
      //
    },

    logPurchase() {
      // let param = {
      //     currency: 'EUR',
      //     value: this.total,
      //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems)),
      //     usecase: this.usecase
      // };
      // for (let itm of store.getters.cartItems) {
      //     let isCoupon = 'nameToDisplay' in itm;
      //     if (isCoupon) {
      //         param.coupon = itm.nameToDisplay;
      //         break
      //     }
      // }
      // firebaseUtil.gevent('purchase', param);
    },


    // updateMinOrderAmount() {
    //     if (store.getters.selectedStore.minOrderAmount) {
    //         this.minOrderAmount = store.getters.selectedStore.minOrderAmount;
    //         this.fee = store.getters.selectedStore.fee;
    //     }
    // },

    // updateDeliveryFee() {
    //     this.deliveryFee = 0;
    //     this.minOrderAmount = 0;
    //     for (let area of appconfig.deliveryAreas) {
    //         if (area.plz === this.deliveryAddress.plz) {
    //             this.deliveryFee = area.fee;
    //             this.minOrderAmount = area.minOrderAmount;
    //             console.log('updateDeliveryFee deliveryFee = ' + area.fee);
    //             console.log('updateDeliveryFee minOrderAmount = ' + area.minOrderAmount);
    //             return true;
    //         }
    //     }
    //     return false;
    // },

    generateOrder() {
      try {
        let order = {
          clientId: '' + this.$ls.get('clientId'),
          lastMenuUpdate: this.$ls.get('lastMenuUpdate'),
          onlinePay: true,
          directPay: true,
          authCompleted: false,
          // simulateTransportError: false, // only to simulate transport error,
          asGuest: !!this.asGuest,
          type: 'selfOrder',
          fuid: (firebaseUtil.getFuid() ? firebaseUtil.getFuid() : null),
          btaste: bootstrap.getBtaste(),
          domain: window.location.hostname,
          channel: 'on-the-go',
          usecase: this.usecase,
          selfServiceEnabled: this.selfServiceEnabled,
          // restaurantId: store.getters.restId,
          createdAt: Date.now(),
          table: 0 + store.getters.table,
          //Note: delayInMinutes is irrelevant for pre-orders (asap === false)
          // delayInMinutes: store.getters.delayInMinutes,
          // expectedDelayInMinutes: store.getters.delayInMinutes,
          orderData: util.cloneMe(store.getters.cartItems),
appliedDiscounts: util.cloneMe(store.getters.appliedDiscounts),
          // company: '' + this.company,
          // userInfo: util.cloneMe(store.state.user),
          // pickupDate: util.cloneMe(this.pickupDate),
          targetTime: Date.now() + (5 * 1000),
          requiresPickupNotification: !!this.selfServiceEnabled,
          abholAdresse: '' + this.abholadresse,
          // onlinePay: this.psp !== 'bar' && this.psp !== 'beiAbholung' && this.psp !== '',
          paymentInfo: {
            // psp: '' + this.psp,
            amount: 0 + this.total,
            tipAmount: 0 + this.secureTip,
            totalWithoutTip: 0 + this.totalWithoutTip,
          },
          paymentAuth: {},
          note: '',
          // invoiceAddress: {
          //   company: '' + this.invoiceAddress.company.trim(),
          //   street: '' + this.invoiceAddress.street.trim(),
          //   plz: this.invoiceAddress.plz,
          //   city: '' + this.invoiceAddress.city.trim(),
          //   // etage: '' + this.deliveryAddress.etage.trim(),
          // }
          // deliveryAddress: {
          //     company: '' + this.deliveryAddress.company.trim(),
          //     street: '' + this.deliveryAddress.street.trim(),
          //     plz: '' + this.deliveryAddress.plz.trim(),
          //     city: '' + this.deliveryAddress.city.trim(),
          //     etage: '' + this.deliveryAddress.etage.trim(),
          // }
        };

        let userSelectedTargetTime = this.$ls.get('userSelectedTargetTime');
        if (userSelectedTargetTime) {
          order.ankunftszeitDate = userSelectedTargetTime // entspricht dem model pickupDate
          order.targetTime = userSelectedTargetTime.utc;
        }

        if (qconst.withPosApi) {
          order.posConfirmedTime = 0;
        }

        if (this.isInvoiceAddressVisible) {
          let invoiceAddress = {
            company: '' + this.invoiceAddress.company.trim(),
            street: '' + this.invoiceAddress.street.trim(),
            plz: this.invoiceAddress.plz,
            city: '' + this.invoiceAddress.city.trim(),
            // etage: '' + this.deliveryAddress.etage.trim(),
          }
          order.invoiceAddress = invoiceAddress;
        }

        // let bbnUser = store.getters.bbnUser;
        // let primaryCardId = bbnUser.primaryCardId;
        // if (primaryCardId && store.getters.loggedIn) {
        //   let card = store.getters.cards.find(c => c.rfid === primaryCardId);
        //   let bbnUser = this.$ls.get('bbnUser');
        //   if (card) {
        //     let orderExtend = {
        //       card: card,
        //       cardId: card.id,
        //     };
        //     Object.assign(order, orderExtend);
        //   }
        //   if (bbnUser) {
        //     let orderExtend = {
        //       userId: bbnUser.id,
        //       userToken: bbnUser.token,
        //     };
        //     Object.assign(order, orderExtend);
        //   }
        // }

        let pushToken = this.$ls.get('pushToken');
        if (pushToken) {
          order.pushToken = pushToken;
        }

        if (store.state.orderArea) {
          order.orderArea = '' + store.state.orderArea;
        }

        if (store.getters.enableStempel) {
          order.collectStempel = true;
          order.stempelType = store.getters.stempelType;
        }
        if (this.note) {
          order.note = '' + this.note;
        }

        order.userInfo = this.getUserInfo();

        // if (!this.sameAsInvoiceAddress) {
        //   order.deliveryAddress = {
        //     company: '' + this.deliveryAddress.company,
        //     street: '' + this.deliveryAddress.street,
        //     plz: this.deliveryAddress.plz,
        //     city: '' + this.deliveryAddress.city,
        //     etage: '' + this.deliveryAddress.etage,
        //   };
        // }//else we only submit the invoiceAddress

        util.sanitizeProps(order);

        //add app string
        // if (breakpoints.getCurrentDevice() === 'xs') {
        //     order.app = 'LIEFERMAXX Mobile App'
        // } else {
        //     order.app = 'LIEFERMAXX App'
        // }

        //add operating system
        try {
          order.userAgentData = window.navigator.userAgentData;
        } catch (e) {

        }

        // if (this.onlinePay) {
        //     // order.orderNumber = this.orderNumber;
        //     // order.uniqueOrderId = this.uniqueOrderId;
        //
        //     order.paymentInfo.psp = 'credit';
        //     // order.paymentInfo.paymentIntentId = this.paymentIntentId;
        //     // order.paymentInfo.aliasId = this.selectedAliasId;
        // }
        // if (this.usecase === 'delivery') {
        //     if (this.deliveryAddress.etage.length > 0) {
        //         order.deliveryAddress.etage = this.deliveryAddress.etage;
        //     }
        order.paymentInfo.itemsTotal = 0 + store.getters.cartSum;
        // order.paymentInfo.deliveryFee = 0;// + store.state.deliveryFee;
        //     // let fee = null;
        //     // for (let area of store.getters.appconfig.deliveryAreas) {
        //     //     if (area.plz === order.deliveryAddress.plz) {
        //     //         fee = area.fee;
        //     //         break;
        //     //     }
        //     // }
        //     // if (fee === null) {
        //     //     //error
        //     //     this.notifyError('Fehler bei den Lieferkosten');
        //     //     return null;
        //     // }
        //     // order.paymentInfo.amount = this.total;
        // } else {
        // order.pickupStore = util.cloneMe(store.getters.selectedStore);
        // delete order.pickupStore.openingHours;
        // order.storeId = '' + store.getters.selectedStore.filialnummer;
        // }
        return util.cloneAndRemoveAllDisplayKeys(order, ['delay']);
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateOrder: ' + e.message));
        return null;
      }
    },

    notifyError(text, err) {
      console.log('error ' + text + ' ' + err);
      ebus.$emit('info', 'Fehler! ' + text + ' ' + (err || ''));
    },

    // notifyInfo(text, err) {
    //     this.$notify({
    //         type: 'info',
    //         title: text,
    //         text: err || ''
    //     });
    // },

    // focusNextField(nextFieldIndex) {
    //   const fields = ['email', 'phone', 'note'];
    //   const nextField = this.$refs[fields[nextFieldIndex - 1]];
    //
    //   if (nextField) {
    //     nextField.focus();
    //   }
    // },
  }
}

</script>

<style lang="scss" scoped>
@import '../styles/base';
@import '../styles/forms';
@import '../styles/tip';

.page {
  /*To debug textfield background*/
  //background-color: $color-secondary;

  select {
    -moz-appearance: menulist !important;
    -webkit-appearance: menulist !important;
  }
}


.datefields {
  width: 70%;
  min-width: 250px;
  max-width: 350px;
}

.termin {
  margin: 8px 0 8px 8px;
}


.actions {

  td {
    text-align: left;
    padding: 1.5%;
  }
}

.bestelldaten {
  /*<!--background-color: $color-darkblue;-->*/

  tr {
    td:first-child {
      color: rgba(black, 0.7)
    }

    td:last-child {
      padding-left: 15px;
      /*color: black;*/
    }

  }

}

/*.vvd {*/
/*    background-color: rgba(white,0.7);*/
/*}*/


.ccard {
  margin-right: 16px;
  background: none;
  color: $font-color;
  //border-left: 6px solid $accent;
  //border-radius: $box-border-radius;
  padding: 8px;
  //@include material-shadow(1);

  /*<!--&:hover {-->*/
  /*<!--    @include material-shadow(2);-->*/
  /*<!--}-->*/

  .expLabel {
    font-size: smaller;
  }
}

/*.page ::v-deep .v-stepper__content{*/
/*    margin-left: 33px;*/
/*}*/




.mar-15 {
  margin-right: 15px;
}

@media only screen and (max-width: 450px) {

  .tipBox {
  }
  .mar-15 {
    margin-right: 8px;
  }
}

</style>
